import React, { useState, useEffect, useRef, useMemo } from "react";

import "./App.css";

import chevaletFr from "./assets/chevalet.png";
import chevaletEn from "./assets/chevalet-en.png";
import accueilJourFr from "./assets/accueil-jour.png";
import accueilJourEn from "./assets/accueil-jour-en.png";

import fondChevaletAudio from "./assets/fond-chevalet.mp3";
import { DUAS_FR } from "./data/duas.fr";
import { DUAS_EN } from "./data/duas.en";
import DhikrCounter from "./components/DhikrCounter";
import ThemeModal from "./components/ThemeModal";
import { getThemePref, setThemePref } from "./assets/theme/themeManager";
import { getLockState, canOpenTile, markTileOpened, formatWait } from "./utils/tileLock";
import { shareMuhasabaApp } from "./utils/shareApp";
import ReminderSettings from "./components/ReminderSettings";
import { applySavedReminder } from "./utils/reminder";
import AdhkarPage from "./adhkar/AdhkarPage";
import "./adhkar/adhkar.css";
import "./welcome.css";
import { loadRemoteConfig, forceRefreshRemoteConfig } from "./utils/remoteConfig";
import NewsButton from "./components/Promos/NewsButton";
import DonateButton from "./components/Promos/DonateButton";
import AnnualDonatePopup from "./components/Promos/AnnualDonatePopup";
import WhyPrayPopup from "./components/Promos/WhyPrayPopup";
import "./components/Promos/promos.css";


// ✅ audios "invocations du sommeil"
import alBaqara285286Ar from "./assets/audio/sleep/al-baqara-285-286/al-baqara-285-286-ar.mp3";
import alFalaqAr from "./assets/audio/sleep/al-falaq/al-falaq-ar.mp3";
import alIkhlasAr from "./assets/audio/sleep/al-ikhlas/al-ikhlas-ar.mp3";
import alMulkAr from "./assets/audio/sleep/al-mulk/al-mulk-ar.mp3";
import anNasAr from "./assets/audio/sleep/an-nas/an-nas-ar.mp3";
import ayatAlKursiAr from "./assets/audio/sleep/ayat-al-kursi/ayat-al-kursi-ar.mp3";
console.log("DUAS_FR:", DUAS_FR.length, "DUAS_EN:", DUAS_EN.length);

// 🔑 Clés de stockage
const ANSWERS_STORAGE_KEY = "chevalet_answers_v2";
const COMPLETED_STORAGE_KEY = "chevalet_completed_v2";
const TILE_STATUS_STORAGE_KEY = "chevalet_tile_status_v1";
const GRID_HINT_STORAGE_KEY = "chevalet_grid_hint_closed_v1";
const CYCLE_DONE_STORAGE_KEY = "chevalet_cycle_done_v1";
const SLEEP_CHECKED_STORAGE_KEY = "chevalet_sleep_checked_v1";
const FIRST_OPEN_ABOUT_KEY = "chevalet_first_open_about_v1";


  const getLocalDayNumber = () => {
  const now = new Date();
  const localMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.floor(localMidnight.getTime() / 86400000);
};
const getDuaOfTheDay = (duas) => {
  const idx = getLocalDayNumber() % duas.length;
  return duas[idx];
};



// ✅ Reset quotidien (minuit local) pour les checkboxes sleep
const DAILY_RESET_KEY = "chevalet_daily_reset_v1";

// ✅ Taille AR réglable (sleep) + persistance
const SLEEP_AR_FONT_SCALE_KEY = "chevalet_sleep_ar_scale_v1";

// ✅ Lien chevalet papier (à remplir plus tard)
const PAPER_EASEL_URL_FR = ""; // <-- tu mettras le lien landing ici plus tard
const PAPER_EASEL_URL_EN = ""; // <-- idem EN

// ✅ Nettoyage des emojis/icônes dans les intros de questions (ex: 🧘‍♀️, 🕋, etc.)
function stripEmojis(text = "") {
  try {
    return String(text)
      .replace(/[\p{Extended_Pictographic}\uFE0F]/gu, "")
      .replace(/\s{2,}/g, " ")
      .trim();
  } catch {
    // fallback simple si un navigateur ne supporte pas \p{...}
    return String(text)
      .replace(/[\u2190-\u21FF\u2300-\u23FF\u2600-\u27BF\uD83C-\uDBFF\uDC00-\uDFFF]/g, "")
      .replace(/\s{2,}/g, " ")
      .trim();
  }
}

function cleanIntro(intro) {
  const s = stripEmojis(intro || "");
  return s ? s.replace(/^\s*[-–•]\s*/g, "").trim() : "";
}

// 🔤 Textes FR / EN
const TEXTS = {
  fr: {
    welcomeAboutButton: "À propos",

 // ABOUT (FR)
aboutTitle: "À propos de ce support de Muhasaba",
aboutLine1:
  "As-salâm 'alaykoum.\n\nAvec les occupations du quotidien, on oublie parfois de s’arrêter quelques minutes pour faire la muhasaba : se remettre en question avec sincérité, se recentrer et revenir vers Allah.",
aboutLine2:
  "C’est dans cet objectif que nous avons créé cet outil d’organisation : t’aider à te réserver un moment de réflexion, sans pression, à ton rythme, avec la permission d’Allah.",

// ✅ NEW (FR) -> ira sous "Lire la suite"
aboutUseAtYourPace:
  "Tu peux l’utiliser pour faire le point, purifier ton intention et travailler à la réforme de ton âme, avec la permission d’Allah.",

aboutShareTitle: "Un outil gratuit à partager autour de toi",
aboutShareText:
  "Si ce support t’aide, tu peux le partager autour de toi. Et si tu le souhaites, laisser une note et un avis sur Google peut aider d’autres personnes à le trouver, si Allah le veut.",
aboutMoreTitle: "Notre mission",
aboutMoreText:
  "Aider les cœurs à se rapprocher d’Allah avec des supports sobres, utiles et respectueux de nos valeurs.",
aboutGoButton: "Accéder au support",





    aboutFreebieButton: "Lire notre mission",
    aboutListenTitle: "Tu préfères écouter ?",
    aboutAudioPlay: "Écouter cette présentation en audio",
    aboutAudioPause: "Arrêter l’audio",
    aboutCreditsTitle: "Crédits",
    aboutCreditsText:
      "Traduction FR : Muhammad Hamidullah • Traduction EN : Sahih International • Récitation : AlphaC • Textes coraniques récupérés via l’API alquran.cloud.",

   // MISSION (in-app)
missionTitle: "Notre mission",
missionTagline:
  "Des outils et supports bénéfiques pour accompagner les cœurs et les familles musulmanes.",
missionWhyTitle: "Notre mission",
missionWhyText: `Notre mission est de proposer des outils et supports bénéfiques, destinés à accompagner les cœurs et les familles musulmanes dans leur cheminement spirituel.

Le support de Muhasaba est proposé gratuitement,
dans une intention de partage, de sincérité et de bienveillance.`,
missionIntentTitle: "Soutenir le projet (optionnel)",
missionIntentText: `Pour celles et ceux qui souhaitent soutenir ce travail,
un don entièrement optionnel est possible.
Il permet de soutenir le temps de création et d’assurer la continuité du projet.

Ce projet est porté avec la volonté de rester accessible,
sans pression, et dans le respect de chacun.`,
missionGoalTitle: "Pour plus tard",
missionGoalText: `Ce projet continue de grandir. Afin d’en assurer la pérennité et la qualité, de nouveaux supports éducatifs, spirituels et familiaux, proposés en version payante, verront progressivement le jour. Leur acquisition permettra de soutenir un travail de création indépendant et de contribuer à l’élaboration de ressources utiles à la communauté, dans une démarche mesurée et sincère, in shaa Allah.`,
missionOfferTitle: "Merci",
missionOfferText: `Qu’Allah accepte ce travail, le rende utile, et nous accorde la sincérité.

Amîne.`,
missionPrinciplesTitle: "Nos principes",
missionPrinciplesText: `• Sincérité et bienveillance
• Sobriété et respect
• Accessibilité, sans pression
• Recherche du bien, bi idhnillah`,
missionAudienceTitle: "À qui cela s’adresse ?",
missionAudienceText: `À toute personne qui souhaite avancer avec Allah,
prendre soin de son cœur, et retrouver un moment de calme, quand tu le peux.`,
missionSupportTitle: "Nous contacter",
missionSupportText:
  "Si tu veux nous écrire (remarque, correction, suggestion), tu peux nous contacter ici :",
missionContactLabel: "Contact :",
missionContactValue: "contactdhikrallah@mafoiislamique.com",
missionBack: "Revenir",



    // FLOW
    startButton: "Faire ma petite réflexion",

   introTitle: "Comment utiliser ce support de Muhasaba ?",
introLine1: "Quand tu le peux, choisis une case et réponds avec sincérité aux questions.",
introLine2:
  "Les questions de la case que tu choisis ne correspondront pas toujours exactement à ce que tu as vécu aujourd’hui, et ce n’est pas grave.",
introLine3:
  "L’idée est de t’inspirer, in shaa Allah : faire le point sur ta journée et préparer ton cœur pour demain… ou pour un autre moment. Ces questions sont des repères : tu peux les adapter, ou utiliser tes propres questions selon ton besoin.",
introLineExtra:
  "Si tu le souhaites, tu peux cocher une case si tu as fait l’action récemment. C’est la sincérité qui compte.",
introLine4:
  "Les mêmes questions reviennent souvent, car l’essentiel ne réside pas dans la quantité, mais dans la présence du cœur : prière, comportement, bonnes actions…",
introLine5:
  "Pour rester simple, tu peux te limiter à une seule case à la fois, avec trois questions : une question essentielle et deux autres, pour t’aider à vraiment réfléchir.",
introLine6:
  "Quand tu auras parcouru l’ensemble des cases, tu pourras simplement recommencer quand tu en ressens le besoin, pour t’aider à garder le cap, in shaa Allah. Le support est structuré en 30 cases et 3 questions par case pour t’aider à avancer simplement, étape par étape. Ce nombre est un choix d’organisation et ne doit pas être compris comme une recommandation religieuse en soi. Le du‘a du jour est volontairement simple : il vise un seul point à améliorer avec l’aide d’Allah. Relis-le idéalement plusieurs fois dans la journée, fais ta part… puis place ta confiance en Allah.",

    introListenTitle: "Tu préfères écouter ?",
    introListenText: "Tu peux écouter ces consignes en audio si tu es fatigué(e) de lire.",
    introAudioPlay: "Écouter ces consignes en audio",
    introAudioPause: "Arrêter l’audio",
    introButton: "Choisir une case ",

    verseTitle: "Rappel : le pardon et la miséricorde d’Allah",
    verseRef:
      "« Dis : Ô Mes serviteurs qui avez commis des excès contre vous-mêmes, ne désespérez pas de la miséricorde d’Allah. » (Sourate 39, verset 53)",
    verseText:
      "Même si ta journée n’a pas été parfaite, Allah pardonne à celui qui revient vers Lui, demande pardon, s’efforce de s’éloigner des péchés et veut s’améliorer.",
    verseHint:
      "Lis ce verset calmement, écoute la récitation et laisse ces paroles te rappeler Allah et renforcer ton intention in shaa Allah.",
    verseButton: "Accueil du Muhasaba",
    verseAudioPlay: "Écouter la récitation de ce verset",
    verseAudioPause: "Arrêter la récitation",

    gridTitle: "Ton support de Muhasaba ",
    gridSubtitle: "Choisis une case pour aujourd'hui.",
    bottomTip: "N'oublie pas de faire aussi tes invocations de la nuit avant de dormir.",

    gridHintTitle: "Petit repère couleurs pour les cases",
    gridHintGreen: "Vert : au moins 2 réponses « Oui »",
    gridHintYellow: "Jaune : 1 réponse « Oui »",
    gridHintRed: "Rouge : 0 « Oui » (zone d’alerte)",
    gridHintHelp:
      "Note le nombre de cases rouges quelque part et essaye de les améliorer petit à petit, sans te culpabiliser.",

    tileTitle: (id) => `Réflexion — Case ${id}`,
    tileIntro1: "Réponds avec sincérité : ce moment est entre toi et Allah.",
    tileIntro2: "Pense à demander pardon à Allah autant que possible.",

    tileNonJudgment: "Le Prophète ﷺ a dit : « Je n’ai été envoyé que pour parfaire les nobles comportements. » (Mâlik, Al-Muwatta’ ; authentifié par Al-Albânî, Silsila As-Sahîha n°45.)",
    tileSpiritLine: "Allah regarde l’intention et l’effort, pas la perfection.",

    tileColorNote:
      "Les couleurs de chaque case sont là pour t’aider, pas pour te culpabiliser . C’est seulement un repère pour voir où progresser, et tu peux toujours faire mieux, in chaa Allah.",
    finishButton: "Terminer ma réflexion ",
    answers: ["Oui", "Non", "J'ai essayé", "Pas encore"],

   conclusionTitle: "Un moment pour se recentrer…",
conclusionLine1:
  "Remercie Allah pour ce qui s’est bien passé aujourd’hui et regrette sincèrement ce qui Lui a déplu.",
conclusionLine2:
  "Demande-Lui de te pardonner, de protéger ton cœur et de t’accorder du bien, aujourd’hui et pour la suite, in shaa Allah.",
conclusionLine3: "N’oublie pas qu’Allah t’aime.",
conclusionDua:
  "« Ô Allah, pardonne-moi mes péchés passés et futurs, ceux que j’ai cachés et ceux que j’ai commis au grand jour. »",
conclusionForYouTitle: "Dou‘a pour toi :",
conclusionForYouText:
  "qu’Allah te pardonne, t’accorde le meilleur de ce monde et de l’au-delà, protège ton cœur et ta famille, et te facilite un chemin de lumière jusqu’à Lui. Amîne.",
conclusionAdviceTitle: "Petit conseil :",
conclusionAdviceText:
  "Essaie de prendre quelques instants pour faire ton petit bilan de temps en temps. Même quelques minutes peuvent faire du bien au cœur, par la permission d’Allah. Si tu sens de la fatigue ou du découragement, cherche refuge auprès d’Allah.",
conclusionReminder:
  "Nous t’encourageons à lire régulièrement les invocations du sommeil, ainsi que celles du matin et du soir : elles apaisent et protègent le cœur, par la permission d’Allah.",

    backToTiles: "Revenir aux cases",
    conclusionAudioPlay: "Écouter le rappel en audio",
    conclusionAudioPause: "Arrêter l’audio",

    // ✅ bouton demandé
    conclusionListenButton: "Prendre un moment avec ce rappel",

    langFr: "FR",
    langEn: "EN",
    bgOn: "Fond activé",
    bgOff: "Fond désactivé",

    gridHintButton: "Règles des couleurs",
    quitTonight: "Quitter pour ce soir",
    readMore: "Lire la suite",
    resetMonth: "Réinitialiser le mois",
resetAllButton: "Réinitialiser",
resetAllConfirm:
  "Réinitialiser l’application ?\n\nCela effacera tes réponses, les couleurs des cases, et ta progression (y compris les invocations du sommeil).",

    monthSummaryTitle: "Voir mon bilan",
    monthSummaryGreen: "Cases vertes",
    monthSummaryYellow: "Cases jaunes",
    monthSummaryRed: "Cases rouges",

    monthSummaryNoteTitle: "Rappel important",
    monthSummaryNonJudgment:
      "Ce bilan n’est pas un jugement. C’est un repère bienveillant pour t’aider à avancer avec sincérité, à ton rythme.",
    monthSummaryGreenNote:
  "Note d’attention : si tu as beaucoup de cases vertes, Alhamdulillah. Rappelle-toi que toute réussite vient d’Allah : remercie-Le, demande-Lui la sincérité, et continue à progresser avec humilité.",

      monthSummaryHadith:
      "« Les œuvres les plus aimées d’Allah sont les plus régulières, même si elles sont peu nombreuses. »",
    monthSummaryHadithHint:
      "Même un petit pas compte. L’essentiel est de revenir vers Allah avec constance.",

    q2Title: "Question 2",
    q3Title: "Question 3",

    sleepTitle: "Invocations du sommeil",
    sleepIntro: "Tu peux écouter ici quelques récitations recommandées avant de dormir.",

    sleepArHelp: "A- / A+ : ajuster la taille du texte.",

    sleepFold1Title: "Invocations du sommeil",
    sleepFold2Title: "Pour aller plus loin",

    sleepTipTitle: "Astuce",
    sleepTipText:
      "Besoin d'un rappel visuel ? support mémo de Muhasaba à faire en DIY et à poser près de ton lit. Idéal pour garder l'intention, tout en gardant la simplicité du numérique pour valider ta journée in shaa Allah.",
    sleepTipBtn: "Voir le support mémo de Muhasaba papier",
    sleepTipSoon: "Bientôt disponible",

    paperTitle: "Muhasaba papier (mémo) DIY",
    paperSubtitle: "Un support simple à poser près du lit, pour garder l’intention et faciliter la constance.",
    paperWhatTitle: "Ce que tu y trouveras",
    paperWhatText:
      "• Un mémo visuel facile à relire\n• Une présentation sobre, sans distraction\n• Un rappel pour revenir à l’essentiel si Allah le permet",
    paperDownloadTitle: "Téléchargement",
    paperDownloadText: "Le lien sera ajouté ici dès que la landing page sera prête, in shaa Allah.",
    paperDownloadBtn: "Télécharger le support de Muhasaba papier",
    paperBackBtn: "Retour",

    sleepBack: "Retour à l'acceuil",
    sleepPlay: "Écouter",
    sleepPause: "Arrêter",
    sleepTrackBaqara: "Al-Baqara (285–286)",
    sleepTrackKursi: "Ayat al-Kursi",
    sleepTrackIkhlas: "Al-Ikhlas x 3",
    sleepTrackFalaq: "Al-Falaq x 3",
    sleepTrackNas: "An-Nas x 3",
    sleepTrackMulk: "Al-Mulk",
   sleepDhikrSubhanallah: "SubhanAllah x 33",
sleepDhikrAlhamdulillah: "Alhamdulillah x 33",
sleepDhikrAllahuAkbar: "Allahu Akbar x 34",
    sleepTrackBismika: "Bismika Allahumma…",
    translitLabel: "Phonétique",

    sleepChecked: "Fait",
    sleepProgress: "Progression",
    sleepProgressHint: "Coche ce que tu as récité/lu ou écouté.",

    sleepDoneTitle: "Félicitations",
    sleepDoneText: "Tu as complété tes invocations ce soir. Qu’Allah accepte, Amîne.",

    openLabel: "Ouvrir",
    closeLabel: "Fermer",
    arSmaller: "A-",
    arBigger: "A+",
    arSizeHint: "Taille du texte arabe",

    // ✅ nouveau
    loadingText: "Chargement…",
  },

  en: {
    welcomeAboutButton: "About",

 // ABOUT (EN)
aboutTitle: "About this Muhasaba support",
aboutLine1:
  "As-salāmu 'alaykum.\n\nWith the busyness of everyday life, we sometimes forget to pause for a few minutes for muhasaba: to reflect sincerely, recenter ourselves, and return to Allah.",
aboutLine2:
  "This is why we created this planning tool: to help you set aside a moment for reflection, without pressure, at your own pace, by the will of Allah.",

// ✅ NEW (EN) -> ira sous "Read more"
aboutUseAtYourPace:
  "You can use it to reflect, purify your intention, and work on the reform of your soul, with Allah's permission.",

aboutShareTitle: "A free tool to share around you",
aboutShareText:
  "If this support helps you, feel free to share it with others. And if you wish, leaving a rating and a review on Google can help others find it too, if Allah wills.",
aboutMoreTitle: "Our mission",
aboutMoreText:
  "Helping hearts draw closer to Allah through simple, useful, and value-respecting resources.",
aboutGoButton: "Access the guide",




  
    aboutFreebieButton: "Read our mission",
    aboutListenTitle: "Do you prefer listening?",
    aboutAudioPlay: "Listen to this presentation in audio",
    aboutAudioPause: "Stop the audio",
    aboutCreditsTitle: "Credits",
    aboutCreditsText:
      "FR translation: Muhammad Hamidullah • EN translation: Sahih International • Recitation: AlphaC • Qur’anic texts fetched via the alquran.cloud API.",

   // MISSION (in-app)
missionTitle: "Our mission",
missionTagline:
  "Beneficial tools and resources to support hearts and Muslim families.",
missionWhyTitle: "Our mission",
missionWhyText: `Our mission is to offer beneficial tools and resources,
designed to support hearts and Muslim families
in their spiritual journey.

The Muhasaba support is provided for free,
with an intention of sharing, sincerity, and kindness.`,
missionIntentTitle: "Support the project (optional)",
missionIntentText: `For those who wish to support this work,
a fully optional donation is possible.
It helps support the time spent creating and ensures the continuity of the project.

This project is carried with the intention to remain accessible,
without pressure, and with respect for everyone.`,
missionGoalTitle: "Later on",
missionGoalText: `This project continues to grow. In order to ensure its sustainability and quality, new educational, spiritual, and family-oriented resources, offered in a paid format, will gradually be developed. Their acquisition will help support independent creative work and contribute to the development of meaningful resources for the community, in a measured and sincere approach, in shaa Allah.`,
missionOfferTitle: "Thank you",
missionOfferText: `May Allah accept this work, make it beneficial, and grant us sincerity.

Ameen.`,
missionPrinciplesTitle: "Our principles",
missionPrinciplesText: `• Sincerity and kindness
• Simplicity and respect
• Accessibility, without pressure
• Seeking good, by Allah’s permission`,
missionAudienceTitle: "Who is this for?",
missionAudienceText: `For anyone who wants to move forward with Allah,
take care of their heart, and find a calm moment, when you can.`,
missionSupportTitle: "Contact us",
missionSupportText:
  "If you’d like to write to us (note, correction, suggestion), you can contact us here:",
missionContactLabel: "Contact:",
missionContactValue: "contactdhikrallah@mafoiislamique.com",
missionBack: "Back",



    // FLOW
    startButton: "Take a moment to reflect",

    introTitle: "How to use this Muhasaba support?",
introLine1: "When you can, choose a tile and answer the questions sincerely.",
introLine2:
  "The questions in the tile you choose may not always match exactly what you experienced today, and that’s okay.",
introLine3:
  "They are there to inspire you, in shaa Allah: to reflect on your day and prepare your heart for tomorrow… or for another time. These questions are simply guidelines: you can adapt them, or use your own questions depending on your needs.",
introLineExtra:
  "If you wish, you can tick a tile if you did that action recently. What matters is sincerity.",
introLine4:
  "The same questions recur, as the focus is not on quantity but on the presence of the heart: prayer, character, good deeds...",
introLine5:
  "To keep it simple, you can focus on one tile at a time, with three questions: one essential question and two others, to help you reflect more deeply.",
introLine6:
  "Once you’ve gone through all the tiles, you can simply start again whenever you feel the need, to help you stay on track, in shaa Allah. This support is structured into 30 tiles and 3 questions per tile to help you move forward simply, step by step. This number is an organisational choice and should not be understood as a religious recommendation in itself. The du‘a of the day is intentionally simple: it focuses on one thing to improve with Allah’s help. Ideally, reread it several times throughout the day, do your part… then place your trust in Allah.",

    introListenTitle: "Do you prefer listening?",
    introListenText: "You can listen to these instructions in audio if you feel too tired to read.",
    introAudioPlay: "Listen to these instructions in audio",
    introAudioPause: "Stop the audio",
    introButton: "Choose a tile ",

    verseTitle: "Reminder: Allah’s pardon and mercy",
    verseRef:
      "“Say: O My servants who have transgressed against themselves, do not despair of the mercy of Allah.” (Surah 39, verse 53)",
    verseText:
      "Even if your day wasn’t perfect, Allah forgives the one who returns to Him, seeks forgiveness, strives to stay away from sins, and wants to improve.",
    verseHint:
      "Read this verse calmly, listen to the recitation, and let these words remind you of Allah and strengthen your intention, in shaa Allah.",
    verseButton: "Muhasaba Home",
    verseAudioPlay: "Listen to the recitation of this verse",
    verseAudioPause: "Stop the recitation",

    gridTitle: "Your Muhasaba support ",
    gridSubtitle: "Choose a tile for today.",
    bottomTip: "Don’t forget to read your evening supplications before sleeping.",

    gridHintTitle: "Small colour guide for the tiles",
    gridHintGreen: 'Green: at least 2 "Yes" answers',
    gridHintYellow: 'Yellow: 1 "Yes" answer',
    gridHintRed: 'Red: 0 "Yes" answers (alert area)',
    gridHintHelp:
      "Write down how many red tiles you have and try to improve them little by little, without feeling guilty.",

    tileTitle: (id) => `Reflection — Tile ${id}`,
    tileIntro1: "Answer sincerely: this time is between you and Allah.",
    tileIntro2: "Remember to ask Allah for forgiveness as much as possible.",

    tileNonJudgment:
      "The Prophet ﷺ said: “I was only sent to perfect noble character.” (Mālik, Al-Muwaṭṭa’; authenticated by Al-Albānī, Silsilat al-Ṣaḥīḥa no. 45.)",
    tileSpiritLine: "Allah looks at intention and effort, not perfection.",

    tileColorNote:
      'The colours of each tile are there to guide you, not to make you feel guilty. It is simply a marker to see where you can improve, and you can always do better, in shaa Allah.',
    finishButton: "End my reflection ",
    answers: ["Yes", "No", "I tried", "Not yet"],

    conclusionTitle: "A moment to recenter…",
conclusionLine1:
  "Thank Allah for what went well today, and sincerely regret what displeased Him.",
conclusionLine2:
  "Ask Him to forgive you, protect your heart, and grant you goodness—today and in the days to come—in shaa Allah.",
conclusionLine3: "Do not forget that Allah loves you.",
conclusionDua:
  "“O Allah, forgive my past and future sins, those I hid and those I committed openly.”",
conclusionForYouTitle: "A du‘a for you:",
conclusionForYouText:
  "may Allah forgive you, grant you the best of this world and the Hereafter, protect your heart and your family, and make easy for you a path of light leading to Him. Āmīn.",
conclusionAdviceTitle: "A gentle reminder:",
conclusionAdviceText:
  "Try to take a few moments from time to time to reflect and take stock. Even a few minutes can bring ease to the heart, by the permission of Allah. If you feel tired or discouraged, seek refuge with Allah.",
conclusionReminder:
  "We encourage you to read the sleep supplications regularly, as well as the morning and evening supplications: they soothe and protect the heart, by the permission of Allah.",

    backToTiles: "Back to tiles",
    conclusionAudioPlay: "Listen to the reminder in audio",
    conclusionAudioPause: "Stop the audio",

    // ✅ bouton demandé (EN)
    conclusionListenButton: "Take a moment with this reminder",

    langFr: "FR",
    langEn: "EN",
    bgOn: "Background on",
    bgOff: "Background off",

    gridHintButton: "Colour guide",
    quitTonight: "Quit for tonight",
    readMore: "Read more",
    resetMonth: "Reset the month",
resetAllButton: "Reset",
resetAllConfirm:
  "Reset the app?\n\nThis will erase your answers, tile colours, and your progress (including sleep recitations).",

    monthSummaryTitle: "See my summary",
    monthSummaryGreen: "Green tiles",
    monthSummaryYellow: "Yellow tiles",
    monthSummaryRed: "Red tiles",

    monthSummaryNoteTitle: "Important reminder",
    monthSummaryNonJudgment:
      "This check-in is not a judgment. It’s a gentle guide to help you move forward sincerely, at your own pace.",
    monthSummaryGreenNote:
  "Note of caution: if you have many green boxes, Alhamdulillah. Remember that every success comes from Allah: thank Him, ask Him for sincerity, and keep moving forward with humility.",

      monthSummaryHadith:
      "“The deeds most loved by Allah are those done consistently, even if they are small.”",
    monthSummaryHadithHint:
      "Even a small step matters. What matters most is returning to Allah with consistency.",

    q2Title: "Question 2",
    q3Title: "Question 3",

    sleepTitle: "Sleep recitations",
    sleepIntro: "You can listen here to a few recommended recitations before sleeping.",

    sleepArHelp: "A- / A+ : adjust the text size.",

    sleepFold1Title: "Sleep recitations",
    sleepFold2Title: "To go further",

    sleepTipTitle: "Tip",
    sleepTipText:
      "Need a visual reminder? Download our Muhasaba memo (DIY) to keep near your bed. It helps you stay focused, while keeping the digital check-in simple.",
    sleepTipBtn: "View the paper Muhasaba memo",
    sleepTipSoon: "Coming soon",

    paperTitle: "Paper Muhasaba memo DIY",
    paperSubtitle: "A simple bedside support to keep your intention and strengthen consistency.",
    paperWhatTitle: "What you’ll find",
    paperWhatText:
      "• A visual memo easy to review\n• A sober layout, without distractions\n• A reminder to return to the essentials each night",
    paperDownloadTitle: "Download",
    paperDownloadText: "The link will be added here as soon as the landing page is ready, in shaa Allah.",
    paperDownloadBtn: "Download the paper memo",
    paperBackBtn: "Back",

    sleepBack: "Go to Muhasaba",
    sleepPlay: "Play",
    sleepPause: "Stop",
    sleepTrackBaqara: "Al-Baqara (285–286)",
    sleepTrackKursi: "Ayat al-Kursi",
    sleepTrackIkhlas: "Al-Ikhlas x 3",
    sleepTrackFalaq: "Al-Falaq x 3",
    sleepTrackNas: "An-Nas x 3",
    sleepTrackMulk: "Al-Mulk",
    sleepDhikrSubhanallah: "SubhanAllah (33 times)",
sleepDhikrAlhamdulillah: "Alhamdulillah (33 times)",
sleepDhikrAllahuAkbar: "Allahu Akbar (34 times)",

    sleepTrackBismika: "Bismika Allahumma…",
    translitLabel: "Transliteration",

    sleepChecked: "Done",
    sleepProgress: "Progress",
    sleepProgressHint: " Tick what you've recited, read, listened to.",

    sleepDoneTitle: "Congratulations",
    sleepDoneText: "You completed your sleep adhkar tonight. May Allah accept, Ameen.",

    openLabel: "Open",
    closeLabel: "Close",
    arSmaller: "A-",
    arBigger: "A+",
    arSizeHint: "Arabic text size",

    // ✅ nouveau
    loadingText: "Loading…",
  },
};

// ✅ Bismika (avec phonétique complète)
const SLEEP_BISMIKA = {
  ar: "بِاسْمِكَ اللَّهُمَّ أَمُوتُ وَأَحْيَا",
  translit: "Bismika Allāhumma amūtu wa aḥyā.",
  fr: "En Ton Nom, ô Allah, je meurs et je vis.",
  en: "In Your Name, O Allah, I die and I live.",
};

// 🧩 30 cases
const TILES = Array.from({ length: 30 }, (_, i) => i + 1);

// 🔧 Choisir les 3 questions d’une case en mode SÉCURISÉ
function getTileQuestions(questions, tileId) {
  if (!Array.isArray(questions) || questions.length === 0) return [];

  const qPrayer = questions[0];
  const poolSize = 30; // 30 cases
  const fallback = questions[questions.length - 1] || qPrayer;

  // q2 = série normale (1,3,5,...,59)
  const q2Index = 1 + (tileId - 1) * 2;

  // q3 = même série mais décalée (ça casse la répétition)
  const SHIFT = 11; // tu peux tester 7, 9, 11, 13...
  const q3Tile = ((tileId - 1 + SHIFT) % poolSize) + 1;
  const q3Index = 2 + (q3Tile - 1) * 2; // (2,4,6,...,60) mais décalé

  const q2 = questions[q2Index] || fallback;
  const q3 = questions[q3Index] || fallback;

  return [qPrayer || fallback, q2, q3];
}


// ✅ Bloc repliable "verre"
function CollapsibleBlock({ t, preview = [], more = [], defaultOpen = false }) {
  const hasMore = Array.isArray(more) && more.length > 0;
  return (
    <div style={{ marginTop: "0.25rem" }}>
      {preview.filter(Boolean).map((p, i) => (
        <p key={`p-${i}`} className="panel-subtitle">
          {p}
        </p>
      ))}

      {hasMore && (
        <details
          open={defaultOpen}
          style={{
            marginTop: "0.4rem",
            background: "rgba(15,23,42,0.20)",
            border: "1px solid rgba(148,163,184,0.22)",
            borderRadius: "12px",
            padding: "0.55rem 0.7rem",
          }}
        >
          <summary
            style={{
              cursor: "pointer",
              fontWeight: 800,
              listStyle: "none",
              outline: "none",
              color: "rgba(229,231,235,0.95)",
            }}
          >
            {t.readMore}
          </summary>

          <div style={{ marginTop: "0.55rem" }}>
            {more.filter(Boolean).map((p, i) => (
              <p key={`m-${i}`} className="panel-subtitle secondary">
                {p}
              </p>
            ))}
          </div>
        </details>
      )}
    </div>
  );
}

// ✅ Question repliable
function CollapsibleQuestion({ summaryTitle, intro, text, children, defaultOpen = false }) {
  return (
    <details
      open={defaultOpen}
      style={{
        background: "rgba(15,23,42,0.20)",
        border: "1px solid rgba(148,163,184,0.22)",
        borderRadius: "14px",
        padding: "0.55rem 0.7rem",
        marginBottom: "0.7rem",
      }}
    >
      <summary
        style={{
          cursor: "pointer",
          listStyle: "none",
          outline: "none",
          fontWeight: 900,
          color: "rgba(229,231,235,0.95)",
        }}
      >
        {summaryTitle}
      </summary>

      <div style={{ marginTop: "0.55rem" }}>
        {intro ? (
          <p className="panel-subtitle secondary" style={{ margin: "0 0 0.25rem" }}>
            {intro}
          </p>
        ) : null}

        {text ? (
          <p className="question-text" style={{ margin: 0 }}>
            {text}
          </p>
        ) : null}

        <div style={{ marginTop: "0.65rem" }}>{children}</div>
      </div>
    </details>
  );
}

/**
 * ✅ IMPORTANT
 * QUESTIONS_FR / QUESTIONS_EN : inchangées (emojis supprimés à l'affichage via cleanIntro)
 */
const QUESTIONS_FR = [
  { intro: "Garder la prière au centre de ta journée", text: "As-tu fait de ton mieux pour accomplir tes cinq prières à l’heure aujourd’hui ?" },
  { intro: "Même un petit appel vers Allah compte", text: "As-tu pris au moins un moment aujourd’hui pour invoquer Allah, même quelques secondes ?" },
  { intro: "Ton cœur a besoin de se rappeler d’Allah", text: "As-tu essayé de faire un peu de dhikr aujourd’hui (subhanAllah, alhamdoulillah, Allahu akbar…) ?" },
  { intro: "Le Coran, même un verset, est un rappel", text: "As-tu récité ou lu au moins un verset du Coran aujourd’hui ?" },
  { intro: "Ne pas seulement lire, mais réfléchir au sens", text: "As-tu pris un moment pour réfléchir au sens d’un verset du Coran aujourd’hui ?" },
  { intro: "Une intention sincère donne du sens à l’action", text: "As-tu renouvelé ton intention pour Allah dans au moins une action de ta journée ?" },
  { intro: "Le cœur se nettoie en revenant vers Allah", text: "As-tu demandé pardon à Allah pour une faute aujourd’hui ?" },
  { intro: "Reconnaître les bienfaits d’Allah", text: "As-tu reconnu au moins un bienfait d’Allah sur toi aujourd’hui et exprimé de la gratitude ?" },
  { intro: "Tu n’es jamais seul(e) avec tes inquiétudes", text: "As-tu confié à Allah une peine ou une inquiétude aujourd’hui, plutôt que de tout porter seul(e) ?" },
  { intro: "Une invocation sincère est une cause de bien", text: "As-tu prononcé une invocation sincère aujourd’hui, même très courte ?" },

  { intro: "S’arrêter pour Allah est déjà une victoire", text: "As-tu renoncé à une parole ou une action interdite, par crainte d’Allah ?" },
  { intro: "Même dans l’occupation, le cœur peut se tourner vers Lui", text: "Y a-t-il eu un moment aujourd’hui où tu t’es rappelé(e) d’Allah malgré l’occupation ?" },
  { intro: "Se rappeler qu’Allah te voit", text: "As-tu essayé de te rappeler qu’Allah te voit dans une action ordinaire aujourd’hui ?" },
  { intro: "Une aide donnée pour Allah compte", text: "As-tu aidé quelqu’un aujourd’hui en cherchant surtout l’agrément d’Allah ?" },
  { intro: "Les actes cachés sont précieux", text: "As-tu accompli un bien en secret aujourd’hui, sans chercher à être vu(e) ?" },
  { intro: "Les mots peuvent guérir ou blesser", text: "As-tu fait un effort aujourd’hui pour éviter une parole qui aurait pu blesser quelqu’un ?" },
  { intro: "Pardonner, c’est alléger son cœur", text: "As-tu pardonné ou laissé passer une erreur aujourd’hui, en cherchant l’agrément d’Allah ?" },
  { intro: "La patience dans l’épreuve", text: "Dans une difficulté aujourd’hui, as-tu essayé de rester patient(e) pour Allah ?" },
  { intro: "La vraie force est de retenir sa colère", text: "As-tu retenu ta colère aujourd’hui alors que tu aurais pu répondre durement ?" },
  { intro: "La douceur est une voie aimée", text: "As-tu choisi la douceur dans une situation où la dureté aurait été plus facile ?" },

  { intro: "Honorer les gens comme il convient", text: "As-tu honoré aujourd’hui quelqu’un qui le mérite (parent, proche, voisin, aîné, professeur...) ?" },
  { intro: "Protéger son cœur de la médisance", text: "As-tu fait attention aujourd’hui à ne pas médire d’une personne en son absence ?" },
  { intro: "Être juste, même dans les détails", text: "As-tu essayé d’être juste dans tes paroles ou dans une décision aujourd’hui ?" },
  { intro: "Reconnaître sa faute et réparer", text: "Si tu as blessé quelqu’un aujourd’hui, as-tu demandé pardon ou tenté de réparer ?" },
  { intro: "S’arrêter avant de déplaire à Allah", text: "As-tu évité un comportement dont tu savais qu’il ne plaît pas à Allah ?" },
  { intro: "La compassion est une miséricorde", text: "As-tu montré de la compassion aujourd’hui (écoute, geste, message, sourire) ?" },
  { intro: "La fiabilité est une qualité aimée", text: "As-tu respecté aujourd’hui une promesse ou un engagement que tu avais pris ?" },
  { intro: "Remercier les gens fait partie du bien", text: "As-tu remercié quelqu’un aujourd’hui pour un service, une présence ou un bienfait ?" },
  { intro: "Donner un bon exemple", text: "As-tu donné un bon exemple aujourd’hui, même sans faire de grands discours ?" },
  { intro: "Le silence évite bien des regrets", text: "As-tu choisi le silence plutôt que de t’emporter ou de répondre trop vite ?" },

  { intro: "Donner sans y être obligé", text: "As-tu aidé quelqu’un aujourd’hui alors que tu n’y étais pas obligé(e) ?" },
  { intro: "Éviter l’injustice, même légère", text: "As-tu évité aujourd’hui une injustice, même petite, envers quelqu’un ?" },
  { intro: "Encourager fait partie du bien", text: "As-tu soutenu ou encouragé quelqu’un aujourd’hui ?" },
  { intro: "Ne pas répondre au mal par le mal", text: "As-tu essayé aujourd’hui de ne pas répondre au mal par le mal, même si c’était difficile ?" },
  { intro: "Servir sa famille est un bien", text: "As-tu rendu service à un membre de ta famille aujourd’hui, en cherchant la récompense auprès d’Allah ?" },
  { intro: "Le ton laisse une trace", text: "Dans une discussion difficile aujourd’hui, as-tu essayé de garder un ton respectueux et doux ?" },
  { intro: "Respecter l’autre même en désaccord", text: "As-tu respecté quelqu’un aujourd’hui, même si tu n’étais pas d’accord avec lui/elle ?" },
  { intro: "Faire un effort sur ses pensées", text: "As-tu repoussé une mauvaise pensée aujourd’hui en la remplaçant par une pensée qui plaît à Allah ?" },
  { intro: "Sincérité : purifier le “pourquoi”", text: "As-tu essayé d’améliorer la sincérité de ton intention dans au moins une action aujourd’hui ?" },
  { intro: "Nettoyer son cœur des maladies", text: "As-tu essayé aujourd’hui d’éloigner une jalousie, une rancune ou une mauvaise intention de ton cœur ?" },

  { intro: "Se rappeler les bienfaits qu’Allah t’a donnés", text: "As-tu essayé aujourd’hui de moins te comparer aux autres et de te rappeler ce qu’Allah t’a accordé ?" },
  { intro: "Reposer son cœur en se tournant vers Allah", text: "As-tu pris un moment aujourd’hui pour te recentrer vers Allah (dou‘a, dhikr, silence, réflexion) ?" },
  { intro: "Ce que l’on consomme influence le cœur", text: "As-tu veillé aujourd’hui à éviter ce qui est illicite (images, paroles, contenus, argent…) ?" },
  { intro: "Protéger sa langue", text: "As-tu fait un effort aujourd’hui pour éviter les paroles inutiles ou nuisibles ?" },
  { intro: "Se coucher avec un cœur plus serein", text: "As-tu, si tu le peux, cherché à te coucher avec un cœur plus serein (pardon, dhikr, tawakkul) ?" },
  { intro: "Se rappeler l’au-delà avec sagesse", text: "As-tu pensé à la mort aujourd’hui d’une manière saine, pour te rappeler ta rencontre avec Allah ?" },
  { intro: "Se rappeler le Jour du Jugement", text: "As-tu pensé aujourd’hui au Jour du Jugement et au moment où tu te tiendras devant Allah ?" },
  { intro: "Garder espoir en la miséricorde d’Allah", text: "As-tu nourri aujourd’hui l’espoir en la miséricorde d’Allah, tout en craignant de Lui désobéir ?" },
  { intro: "Lutter contre un défaut", text: "As-tu essayé aujourd’hui de lutter contre une mauvaise habitude ou un défaut ?" },
  { intro: "La sadaqa ne se résume pas à l’argent", text: "As-tu fait une petite sadaqa aujourd’hui (argent, sourire, geste, parole douce…) ?" },

  { intro: "Être là pour les autres", text: "As-tu aidé une personne en difficulté aujourd’hui, même de façon simple ?" },
  { intro: "Soutenir le bien", text: "As-tu soutenu aujourd’hui une action bénéfique ou une bonne cause (partage, participation, encouragement, don…) ?" },
  { intro: "Apprendre quelque chose d’utile", text: "As-tu appris aujourd’hui quelque chose d’utile pour ta foi ou ta pratique ?" },
  { intro: "Conseiller avec douceur", text: "As-tu conseillé tes enfants ou un proche aujourd’hui avec douceur et bienveillance ?" },
  { intro: "Entretenir les liens de famille", text: "As-tu entretenu un lien familial aujourd’hui (appel, message, visite, attention…) ?" },
  { intro: "Bonté envers les parents", text: "As-tu accompli un bien envers un de tes parents aujourd’hui (service, parole douce, attention, dou‘a…) ?" },
  { intro: "Respecter les créatures d’Allah", text: "As-tu respecté aujourd’hui une créature d’Allah (animal, nature, environnement…) ?" },
  { intro: "Penser aussi au long terme", text: "As-tu fait aujourd’hui quelque chose qui peut renforcer ta foi à long terme (projet, formation, habitude) ?" },
  { intro: "Fermer la porte au péché", text: "As-tu évité un péché ou une tentation aujourd’hui, même si c’était difficile ?" },
  { intro: "Continuer à obéir malgré la fatigue", text: "Malgré une fatigue ou une épreuve aujourd’hui, as-tu quand même accompli un bien (prière, aide, bonne parole) pour Allah ?" },
  { intro: "Choisir un acte que tu aimerais retrouver", text: "As-tu accompli aujourd’hui un acte que tu aimerais retrouver devant Allah au Jour du Jugement ?" },];

const QUESTIONS_EN = [
 { intro: "Keeping prayer at the center of your day", text: "Did you do your best to perform your five daily prayers on time today?" },
  { intro: "Even a small call to Allah matters", text: "Did you take at least one moment today to make du‘a to Allah, even for a few seconds?" },
  { intro: "Your heart needs to remember Allah", text: "Did you try to do a little dhikr today (subhanAllah, alhamdulillah, Allahu akbar…)?" },
  { intro: "The Qur’an, even one verse, is a reminder", text: "Did you recite or read at least one verse of the Qur’an today?" },
  { intro: "Not only reading, but reflecting on the meaning", text: "Did you take a moment today to reflect on the meaning of a verse from the Qur’an?" },
  { intro: "A sincere intention gives meaning to an action", text: "Did you renew your intention for Allah in at least one action today?" },
  { intro: "The heart is cleansed by returning to Allah", text: "Did you ask Allah for forgiveness for a mistake today?" },
  { intro: "Recognising Allah’s blessings", text: "Did you recognise at least one blessing from Allah today and express gratitude?" },
  { intro: "You are never alone with your worries", text: "Did you confide a hardship or a worry to Allah today, rather than carrying everything alone?" },
  { intro: "A sincere du‘a is a means of good", text: "Did you make a sincere du‘a today, even a very short one?" },

  { intro: "Stopping for Allah is already a victory", text: "Did you refrain from a forbidden word or action out of fear of Allah?" },
  { intro: "Even when busy, the heart can turn to Him", text: "Was there a moment today when you remembered Allah despite being busy?" },
  { intro: "Remembering that Allah sees you", text: "Did you try to remember that Allah sees you during an ordinary action today?" },
  { intro: "Helping for Allah counts", text: "Did you help someone today seeking mainly Allah’s pleasure?" },
  { intro: "Hidden good deeds are precious", text: "Did you do a good deed in secret today, without seeking to be seen?" },
  { intro: "Words can heal or hurt", text: "Did you make an effort today to avoid words that could have hurt someone?" },
  { intro: "Forgiving lightens the heart", text: "Did you forgive or overlook someone’s mistake today, seeking Allah’s pleasure?" },
  { intro: "Patience during trials", text: "In a difficult situation today, did you try to remain patient for Allah?" },
  { intro: "True strength is holding back anger", text: "Did you hold back your anger today when you could have spoken harshly?" },
  { intro: "Gentleness is a beloved path", text: "Did you choose gentleness in a situation where harshness would have been easier?" },

  { intro: "Honouring people as they deserve", text: "Did you honour someone today who deserves it (a parent, relative, neighbour, elder, teacher…)?" },
  { intro: "Protecting your heart from backbiting", text: "Did you pay attention today to avoid backbiting someone in their absence?" },
  { intro: "Being fair, even in small matters", text: "Did you try to be fair in your words or in a decision you made today?" },
  { intro: "Admitting a mistake and making amends", text: "If you hurt someone today, did you apologise or try to make things right?" },
  { intro: "Stopping before displeasing Allah", text: "Did you avoid a behaviour you knew does not please Allah?" },
  { intro: "Compassion is a mercy", text: "Did you show compassion today (listening, a gesture, a message, a smile)?" },
  { intro: "Reliability is a beloved quality", text: "Did you keep a promise or honour a commitment you made today?" },
  { intro: "Thanking people is part of goodness", text: "Did you thank someone today for a service, their presence, or a kindness?" },
  { intro: "Setting a good example", text: "Did you set a good example today, even without giving long advice?" },
  { intro: "Silence prevents many regrets", text: "Did you choose silence rather than losing your temper or replying too quickly?" },

  { intro: "Giving even when not required", text: "Did you help someone today even though you were not obliged to?" },
  { intro: "Avoiding injustice, even small", text: "Did you avoid an injustice today, even a small one, toward someone?" },
  { intro: "Encouraging is part of goodness", text: "Did you support or encourage someone today?" },
  { intro: "Not repaying harm with harm", text: "Did you try today not to respond to harm with harm, even if it was difficult?" },
  { intro: "Serving your family is a good deed", text: "Did you do a service for a family member today, seeking reward from Allah?" },
  { intro: "Your tone leaves an أثر (impact)", text: "In a difficult discussion today, did you try to keep a respectful and gentle tone?" },
  { intro: "Respecting others even in disagreement", text: "Did you respect someone today, even if you disagreed with them?" },
  { intro: "Making an effort with your thoughts", text: "Did you push away a bad thought today by replacing it with a thought that pleases Allah?" },
  { intro: "Sincerity: purifying your ‘why’", text: "Did you try today to improve the sincerity of your intention in at least one action?" },
  { intro: "Cleansing the heart from its illnesses", text: "Did you try today to remove jealousy, resentment, or a bad intention from your heart?" },

  { intro: "Remembering the blessings Allah gave you", text: "Did you try today to compare yourself less to others and remember what Allah has granted you?" },
  { intro: "Letting the heart rest by turning to Allah", text: "Did you take a moment today to recenter toward Allah (du‘a, dhikr, silence, reflection)?" },
  { intro: "What we consume affects the heart", text: "Did you take care today to avoid what is unlawful (images, words, content, money…)?" },
  { intro: "Protecting your tongue", text: "Did you make an effort today to avoid useless or harmful speech?" },
  { intro: "Going to sleep with a calmer heart", text: "If you can, did you try to go to sleep with a calmer heart (seeking forgiveness, dhikr, tawakkul)?" },
  { intro: "Remembering the Hereafter wisely", text: "Did you remember death today in a healthy way, as a reminder of meeting Allah?" },
  { intro: "Remembering the Day of Judgement", text: "Did you think today about the Day of Judgement and the moment you will stand before Allah?" },
  { intro: "Keeping hope in Allah’s mercy", text: "Did you nurture hope in Allah’s mercy today, while still fearing to disobey Him?" },
  { intro: "Struggling against a flaw", text: "Did you try today to work against a bad habit or a personal flaw?" },
  { intro: "Sadaqa is not only money", text: "Did you give a small sadaqa today (money, a smile, a gesture, kind words…)?" },

  { intro: "Being there for others", text: "Did you help someone in difficulty today, even in a simple way?" },
  { intro: "Supporting good", text: "Did you support a beneficial action or a good cause today (sharing, participating, encouraging, donating…)?" },
  { intro: "Learning something beneficial", text: "Did you learn something beneficial today for your faith or your practice?" },
  { intro: "Advising with gentleness", text: "Did you advise your children or a loved one today with gentleness and kindness?" },
  { intro: "Maintaining family ties", text: "Did you maintain a family tie today (a call, a message, a visit, a thoughtful gesture…)?" },
  { intro: "Kindness toward parents", text: "Did you do a good deed for one of your parents today (service, kind words, attention, du‘a…)?" },
  { intro: "Respecting Allah’s creatures", text: "Did you respect a creature of Allah today (animal, nature, environment…)?" },
  { intro: "Thinking long-term too", text: "Did you do something today that can strengthen your faith in the long term (a project, learning, a habit)?" },
  { intro: "Closing the door to sin", text: "Did you avoid a sin or a temptation today, even if it was difficult?" },
  { intro: "Obeying despite tiredness", text: "Despite tiredness or a trial today, did you still do a good deed (prayer, help, good words) for Allah?" },
  { intro: "Choosing an act you’d love to meet again", text: "Did you do an act today that you would like to find waiting for you before Allah on the Day of Judgement?" },
];

function App() {
  const [view, setView] = useState("about");
 const [whyPrayOpen, setWhyPrayOpen] = useState(false);
 const [donateOpen, setDonateOpen] = React.useState(false);

 const [language, setLanguage] = useState("fr");
  const [currentTile, setCurrentTile] = useState(1);
 // ✅ Remote config (don / pourquoi prie-t-on ?)
  const [remoteConfig, setRemoteConfig] = useState(null);

  const [backgroundOn, setBackgroundOn] = useState(true);
  const [themeMode, setThemeMode] = useState(getThemePref() || "night");
  const [themeModalOpen, setThemeModalOpen] = useState(false);

  const [sessionPaused, setSessionPaused] = useState(false);
useEffect(() => {
  applySavedReminder().catch(() => {});
}, []);
useEffect(() => {
  setWhyPrayOpen(false);
}, [view]);


useEffect(() => {
  let mounted = true;

  (async () => {
    try {
      const cfg = await loadRemoteConfig({ ttlMs: 6 * 60 * 60 * 1000 }); // 6h
      if (mounted) setRemoteConfig(cfg);
    } catch {
      if (mounted) setRemoteConfig(null);
    }
  })();

  return () => {
    mounted = false;
  };
}, []);

  useEffect(() => {
    let rafId = 0;
    let t1 = 0, t2 = 0, t3 = 0;

    const applyVh = () => {
      const vv = window.visualViewport;
      const h =
        Math.round((vv?.height || window.innerHeight) * 0.01 * 100) / 100;
      document.documentElement.style.setProperty("--app-vh", `${h}px`);
    };

    const schedule = () => {
      cancelAnimationFrame(rafId);
      clearTimeout(t1); clearTimeout(t2); clearTimeout(t3);

      applyVh();
      rafId = requestAnimationFrame(applyVh);

      t1 = window.setTimeout(applyVh, 80);
      t2 = window.setTimeout(applyVh, 250);
      t3 = window.setTimeout(applyVh, 600);
    };

    schedule();

    const vv = window.visualViewport;

    window.addEventListener("resize", schedule, { passive: true });
    window.addEventListener("orientationchange", schedule, { passive: true });
    window.addEventListener("pageshow", schedule, { passive: true });
    document.addEventListener("visibilitychange", schedule);
    window.addEventListener("focus", schedule, { passive: true });
    window.addEventListener("blur", schedule, { passive: true });

    vv?.addEventListener("resize", schedule, { passive: true });
    vv?.addEventListener("scroll", schedule, { passive: true });

    return () => {
      cancelAnimationFrame(rafId);
      clearTimeout(t1); clearTimeout(t2); clearTimeout(t3);

      window.removeEventListener("resize", schedule);
      window.removeEventListener("orientationchange", schedule);
      window.removeEventListener("pageshow", schedule);
      document.removeEventListener("visibilitychange", schedule);
      window.removeEventListener("focus", schedule);
      window.removeEventListener("blur", schedule);

      vv?.removeEventListener("resize", schedule);
      vv?.removeEventListener("scroll", schedule);
    };
  }, []);
 
  // ✅ fonction juste ici (PAS dans un autre bloc)
const handleChooseTheme = (mode) => {
  if (!mode) return setThemeModalOpen(false);
  setThemePref(mode);
  setThemeMode(mode);
  setThemeModalOpen(false);
};

const isDayContent =
  themeMode === "day" && !["about", "mission", "sleep", "sleep_read"].includes(view);

  // ✅ Mission ne doit jamais subir le mode jour (visuel uniquement)
const isMission = view === "mission";
const uiThemeMode = isMission ? "night" : themeMode;

// ✅ Shell marron pour les pages "à propos" + "mission"
const isBrownShell = view === "about" || view === "mission";

const appShellStyle = isBrownShell
  ? {
      background:
        "radial-gradient(900px 600px at 50% 10%, rgba(140, 95, 50, 0.40), rgba(18, 12, 9, 0.92))",
      minHeight: "100vh",
    }
  : undefined;

  const todayDua = useMemo(() => {
  const list = language === "fr" ? DUAS_FR : DUAS_EN;
  return getDuaOfTheDay(list);
}, [language]);
useEffect(() => {
  try {
    const seenAbout = window.localStorage.getItem(FIRST_OPEN_ABOUT_KEY) === "1";

    if (seenAbout) {
      
      // ✅ 2ème ouverture : on ne montre pas About
      setView("welcome");

      // ✅ puis on ouvre le modal (petit délai = plus propre)
      setTimeout(() => setThemeModalOpen(true), 0);
    }
  } catch {}
  // eslint-disable-next-line
}, []);

  // ✅ Sleep (nouveau : page dédiée)
  const [sleepReadId, setSleepReadId] = useState(null);
  const [sleepContent, setSleepContent] = useState({});
  const [sleepLoading, setSleepLoading] = useState({});
  const [sleepChecked, setSleepChecked] = useState(() => {
    try {
      const raw = window.localStorage.getItem(SLEEP_CHECKED_STORAGE_KEY);
      if (!raw) return {};
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === "object" ? parsed : {};
    } catch {
      return {};
    }
  });

  const [sleepArScale, setSleepArScale] = useState(() => {
    try {
      const raw = window.localStorage.getItem(SLEEP_AR_FONT_SCALE_KEY);
      const n = raw ? Number(raw) : 1;
      if (!Number.isFinite(n)) return 1;
      return Math.min(1.9, Math.max(0.85, n));
    } catch {
      return 1;
    }
  });

  // ✅ Bilan (30 cases)
  const [cycleDone, setCycleDone] = useState(() => {
    try {
      const raw = window.localStorage.getItem(CYCLE_DONE_STORAGE_KEY);
      return raw === "1";
    } catch {
      return false;
    }
  });

  const [answers, setAnswers] = useState(() => {
    try {
      const raw = window.localStorage.getItem(ANSWERS_STORAGE_KEY);
      if (!raw) return {};
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === "object" ? parsed : {};
    } catch {
      return {};
    }
  });

  const [completedTiles, setCompletedTiles] = useState(() => {
    try {
      const raw = window.localStorage.getItem(COMPLETED_STORAGE_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  });

  const [tileStatus, setTileStatus] = useState(() => {
    try {
      const raw = window.localStorage.getItem(TILE_STATUS_STORAGE_KEY);
      if (!raw) return {};
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === "object" ? parsed : {};
    } catch {
      return {};
    }
  });

  const [showGridHint, setShowGridHint] = useState(() => {
    try {
      const raw = window.localStorage.getItem(GRID_HINT_STORAGE_KEY);
      return raw !== "1";
    } catch {
      return true;
    }
  });

  const audioRef = useRef(null);
  const inlineAudioRef = useRef(null);
  const [inlineAudioId, setInlineAudioId] = useState(null);
// 🔒 État du verrou de case
const [lockStateUI, setLockStateUI] = useState({
  activeTileId: null,
  activeUntil: 0,
  lastOpenedAt: 0,
});


useEffect(() => {
  (async () => {
    const s = await getLockState();
    setLockStateUI(s);
  })();
}, []);
useEffect(() => {
  if (view !== "grid") return;

  (async () => {
    const s = await getLockState();
    setLockStateUI(s);
  })();
}, [view]);

  const t = TEXTS[language];
  // ✅ Couleur Dou'a (1 jour sur 2) — on évite "today" car déjà utilisé ailleurs
  const now = new Date();
  const duaIsGreen = now.getDate() % 2 === 0; // pair = vert, impair = doré
  const duaColorClass = duaIsGreen ? "dua-text--green" : "dua-text--gold";

  const SLEEP_TRACKS = useMemo(
  () => [
    { id: "baqara", title: t.sleepTrackBaqara, src: alBaqara285286Ar, hasText: true },
    { id: "kursi", title: t.sleepTrackKursi, src: ayatAlKursiAr, hasText: true },
    { id: "ikhlas", title: t.sleepTrackIkhlas, src: alIkhlasAr, hasText: true },
    { id: "falaq", title: t.sleepTrackFalaq, src: alFalaqAr, hasText: true },
    { id: "nas", title: t.sleepTrackNas, src: anNasAr, hasText: true },
    { id: "mulk", title: t.sleepTrackMulk, src: alMulkAr, hasText: true },
    { id: "dhikr_subhanallah", title: t.sleepDhikrSubhanallah, src: null },
{ id: "dhikr_alhamdulillah", title: t.sleepDhikrAlhamdulillah, src: null },
{ id: "dhikr_allahuakbar", title: t.sleepDhikrAllahuAkbar, src: null },

    { id: "bismika", title: t.sleepTrackBismika, src: null, hasText: true },
  ],
  [t]
);


  // =========================
  // 💾 Sauvegardes
  // =========================
  useEffect(() => {
    try {
      window.localStorage.setItem(ANSWERS_STORAGE_KEY, JSON.stringify(answers));
    } catch {}
  }, [answers]);

  useEffect(() => {
    try {
      window.localStorage.setItem(COMPLETED_STORAGE_KEY, JSON.stringify(completedTiles));
    } catch {}
  }, [completedTiles]);

  useEffect(() => {
    try {
      window.localStorage.setItem(TILE_STATUS_STORAGE_KEY, JSON.stringify(tileStatus));
    } catch {}
  }, [tileStatus]);

  useEffect(() => {
    try {
      window.localStorage.setItem(CYCLE_DONE_STORAGE_KEY, cycleDone ? "1" : "0");
    } catch {}
  }, [cycleDone]);

  useEffect(() => {
    try {
      window.localStorage.setItem(SLEEP_CHECKED_STORAGE_KEY, JSON.stringify(sleepChecked));
    } catch {}
  }, [sleepChecked]);

  useEffect(() => {
    try {
      window.localStorage.setItem(SLEEP_AR_FONT_SCALE_KEY, String(sleepArScale));
    } catch {}
  }, [sleepArScale]);
// ✅ Afficher "À propos" automatiquement UNIQUEMENT au tout premier lancement
useEffect(() => {
  try {
    const hasSeenAbout =
      window.localStorage.getItem(FIRST_OPEN_ABOUT_KEY) === "1";

    if (!hasSeenAbout) {
      window.localStorage.setItem(FIRST_OPEN_ABOUT_KEY, "1");
      goTo("about");
    }
  } catch (e) {
    // stockage bloqué (mode privé, etc.) -> on ignore
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

  // =========================
  // ✅ Migration douce : si une case est "complétée" mais sans statut,
  // on met medium pour éviter le 29/30 (ancien storage incomplet)
  // =========================
  useEffect(() => {
    if (!Array.isArray(completedTiles) || !completedTiles.length) return;

    const needsFix = completedTiles.some((tile) => !tileStatus?.[tile]);
    if (!needsFix) return;

    setTileStatus((prev) => {
      const next = { ...(prev || {}) };
      completedTiles.forEach((tile) => {
        if (!next[tile]) next[tile] = "medium";
      });
      return next;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // une fois au chargement

  // =========================
  // 🔊 Audio helpers
  // =========================
  const stopInlineAudio = () => {
    if (inlineAudioRef.current) {
      inlineAudioRef.current.pause();
      inlineAudioRef.current = null;
    }
    setInlineAudioId(null);
  };

  const stopBackgroundAudio = () => {
    const a = audioRef.current;
    if (!a) return;
    a.pause();
    try {
      a.currentTime = 0;
    } catch {}
  };

  const stopAllAudio = () => {
    stopInlineAudio();
    stopBackgroundAudio();
  };

  const goTo = (nextView) => {
    setSessionPaused(false);
    setView(nextView);
  };

// 🔒 Ouverture d'une case avec verrou (1 case active pendant LOCK_MS)
const onTileClick = async (tileId) => {
  setSessionPaused(false);

  const now = Date.now();

  // ✅ Toujours relire l'état depuis Preferences (plus fiable)
  const state = await getLockState();
  setLockStateUI(state);

  // ✅ Autoriser la réouverture de la case active tant que le délai n'est pas expiré
  const canReopenActive =
    Number(state?.activeTileId) === Number(tileId) &&
    now < Number(state?.activeUntil || 0);

  // ✅ Règle anti-erreur (corrigée) :
  // Tant qu’il reste des cases grises, on interdit d’ouvrir une case déjà complétée,
  // SAUF si c'est la case active encore dans le délai.
  const isCompleted = completedTiles.includes(tileId);
  const hasRemainingUncompleted = TILES.some((t) => !completedTiles.includes(t));

  if (isCompleted && hasRemainingUncompleted && !canReopenActive) {
    window.alert(
      language === "fr"
        ? "⚠️ Cette case est déjà validée.\n\n✅ Choisis une case grise (non faite) pour continuer."
        : "⚠️ This tile is already completed.\n\n✅ Please choose a grey (unfinished) tile to continue."
    );
    return;
  }

  const verdict = canOpenTile(tileId, state, now);

  // ❌ Bloqué : une autre case est encore en cooldown
  if (!verdict.ok) {
    const waitText = formatWait(verdict.waitMs || 0);

    window.alert(
      language === "fr"
        ? `⏳ Patiente encore ${waitText} avant d’ouvrir une autre case.\n\n✅ Appuie sur OK pour revenir à la conclusion.`
        : `⏳ Please wait ${waitText} before opening another tile.\n\n✅ Tap OK to return to the conclusion.`
    );

    goTo("conclusion");
    return;
  }

  // ✅ Si c’est une nouvelle case, on démarre/actualise le verrou
  if (verdict.reason === "new_tile") {
    const newState = await markTileOpened(tileId, now);
    setLockStateUI(newState);
  }

  // ✅ Ouvrir la case
  setCurrentTile(tileId);
  goTo("tile");
};


  const playInlineAudio = (id, src) => {
    setSessionPaused(false);

    if (inlineAudioRef.current) {
      inlineAudioRef.current.pause();
      inlineAudioRef.current = null;
    }
    const audio = new Audio(src);
    audio.preload = "auto";
    audio.onended = () => {
      if (inlineAudioRef.current === audio) {
        inlineAudioRef.current = null;
        setInlineAudioId(null);
      }
    };
    audio.play().catch(() => {});
    inlineAudioRef.current = audio;
    setInlineAudioId(id);
  };

  // 🎵 Fond sonore (ne joue pas sur verse/sleep/sleep_read)
  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    audio.loop = true;
    audio.volume = 0.15;

    const shouldPlay =
      backgroundOn &&
      !sessionPaused &&
      view !== "verse" &&
      view !== "sleep" &&
      view !== "sleep_read";

    if (shouldPlay) {
      audio.muted = false;
      audio.play().catch(() => {});
    } else {
      audio.pause();
      try {
        audio.currentTime = 0;
      } catch {}
    }
  }, [backgroundOn, view, sessionPaused]);

  // 🛑 Stop petits audios quand on change de vue/langue
  useEffect(() => {
    stopInlineAudio();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language, view]);

  // ▶️ Auto-play verset
  useEffect(() => {
    if (view === "verse") {
      const verseSrc = "/audio/chevalet-verset-arabe.mp3";
      playInlineAudio("verse", verseSrc);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [view]);

  // =========================
  // ✅ Reset quotidien (minuit local) des checkboxes sleep
  // =========================
  const getLocalDateKey = () => {
    const d = new Date();
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  };

  const ensureDailyReset = () => {
    try {
      const today = getLocalDateKey();
      const last = window.localStorage.getItem(DAILY_RESET_KEY);
      if (last !== today) {
        setSleepChecked({});
        window.localStorage.setItem(SLEEP_CHECKED_STORAGE_KEY, JSON.stringify({}));
        window.localStorage.setItem(DAILY_RESET_KEY, today);
      }
    } catch {}
  };

  useEffect(() => {
    ensureDailyReset();

    const onFocus = () => ensureDailyReset();
    const onVisibility = () => {
      if (!document.hidden) ensureDailyReset();
    };

    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVisibility);

    return () => {
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVisibility);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // =========================
  // ✅ Bilan handlers
  // =========================
  const handleAnswerClick = (tileId, questionId, value) => {
    setSessionPaused(false);
    setAnswers((prev) => ({
      ...prev,
      [tileId]: {
        ...(prev[tileId] || {}),
        [questionId]: value,
      },
    }));
  };

  const isSelected = (tileId, questionId, value) =>
    answers[tileId] && answers[tileId][questionId] === value;

  const resetTilesOnly = () => {
    // ✅ reset uniquement les 30 cases
    setSessionPaused(false);
    stopAllAudio();

    setAnswers({});
    setCompletedTiles([]);
    setTileStatus({});
    setCycleDone(false);

    try {
      window.localStorage.removeItem(ANSWERS_STORAGE_KEY);
      window.localStorage.removeItem(COMPLETED_STORAGE_KEY);
      window.localStorage.removeItem(TILE_STATUS_STORAGE_KEY);
      window.localStorage.setItem(CYCLE_DONE_STORAGE_KEY, "0");
    } catch {}
  };

  const confirmResetTilesOnly = () => {
    const msg =
      language === "fr"
        ? "Beau parcours. Qu’Allah te récompense pour tes efforts.\nUn nouveau cycle commence, pour continuer à travailler sur soi-même, in shaa Allah."
        : "Beautiful progress. May Allah reward your efforts.\nA new cycle begins, to keep working on oneself, in shaa Allah.";
    if (window.confirm(msg)) resetTilesOnly();
  };

  // =========================
  // ✅ Sleep helpers
  // =========================
  const toggleSleepChecked = (id) => {
    setSleepChecked((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const sleepProgressCount = React.useMemo(() => {
    const ids = SLEEP_TRACKS.map((x) => x.id);
    return ids.reduce((acc, id) => acc + (sleepChecked[id] ? 1 : 0), 0);
 }, [sleepChecked, SLEEP_TRACKS]);


  const quitForTonight = () => {
    // ✅ quand on quitte : reset invocations + retour accueil
    setSessionPaused(true);
    stopAllAudio();

    setSleepChecked({});
    try {
      window.localStorage.setItem(SLEEP_CHECKED_STORAGE_KEY, JSON.stringify({}));
    } catch {}

    setSleepReadId(null);
    setView("welcome");
  };

  const stats = React.useMemo(() => {
    const vals = Object.values(tileStatus || {});
    const green = vals.filter((v) => v === "good").length;
    const yellow = vals.filter((v) => v === "medium").length;
    const red = vals.filter((v) => v === "bad").length;
    const total = green + yellow + red;
    const completed = Array.isArray(completedTiles) ? completedTiles.length : 0;
    return { green, yellow, red, total, completed };
  }, [tileStatus, completedTiles]);

  // =========================
  // ✅ Sleep content fetch
  // =========================
  const AR_EDITION = "quran-uthmani";
  const FR_EDITION = "fr.hamidullah";
  const EN_EDITION = "en.sahih";

  const SLEEP_MAP = {
    baqara: { type: "ayahs", ayahs: ["2:285", "2:286"] },
    kursi: { type: "ayahs", ayahs: ["2:255"] },
    ikhlas: { type: "surah", surah: 112, forceBasmalaSeparation: true },
    falaq: { type: "surah", surah: 113, forceBasmalaSeparation: true },
    nas: { type: "surah", surah: 114, forceBasmalaSeparation: true },
    mulk: { type: "surah", surah: 67, forceBasmalaSeparation: true },
    dhikr_subhanallah: { type: "dhikr" },
dhikr_alhamdulillah: { type: "dhikr" },
dhikr_allahuakbar: { type: "dhikr" },

    bismika: { type: "dua" },
  };

  const separateBasmalaIfNeeded = (ayahs) => {
    if (!Array.isArray(ayahs) || ayahs.length === 0) return ayahs || [];
    const first = String(ayahs[0] || "").trim();
    const basmalaRx =
      /^(بِسْمِ\s+(?:ٱ|ا)?للَّهِ\s+(?:ٱ|ا)?لرَّحْمَٰنِ\s+(?:ٱ|ا)?لرَّحِيمِ)\s*/;

    const m = first.match(basmalaRx);
    if (!m) return ayahs;

    const basmala = m[1].trim();
    const rest = first.slice(m[0].length).trim();

    const out = [];
    out.push(basmala);
    if (rest) out.push(rest);
    for (let i = 1; i < ayahs.length; i++) out.push(ayahs[i]);
    return out;
  };

  const ensureLoaded = async (id) => {
    if (!id) return;
    if (sleepContent[id] || sleepLoading[id]) return;

    const conf = SLEEP_MAP[id];
    if (!conf) return;

    if (conf.type === "dua") {
      setSleepContent((prev) => ({
        ...prev,
        [id]: {
          arLines: [SLEEP_BISMIKA.ar],
          translit: SLEEP_BISMIKA.translit,
          frLines: [SLEEP_BISMIKA.fr],
          enLines: [SLEEP_BISMIKA.en],
        },
      }));
      return;
    }
if (conf.type === "dhikr") {
  const DHIKR = {
    dhikr_subhanallah: {
      ar: "سُبْحَانَ اللَّهِ",
      fr: "Gloire et pureté à Allah.",
      en: "Glory be to Allah.",
    },
    dhikr_alhamdulillah: {
      ar: "ٱلْحَمْدُ لِلَّهِ",
      fr: "Louange et remerciement à Allah.",
      en: "All praise and thanks be to Allah.",
    },
    dhikr_allahuakbar: {
      ar: "ٱللَّهُ أَكْبَرُ",
      fr: "Allah est le Plus Grand.",
      en: "Allah is the Greatest.",
    },
  };

  const d = DHIKR[id];

  setSleepContent((prev) => ({
    ...prev,
    [id]: {
      arLines: d ? [d.ar] : [],
      frLines: d ? [d.fr] : [],
      enLines: d ? [d.en] : [],
    },
  }));
  return;
}


    setSleepLoading((prev) => ({ ...prev, [id]: true }));

    try {
      const fetchJson = async (url) => {
        const res = await fetch(url);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      };

      const pick = (arr, identifier) =>
        (arr || []).find((x) => x?.edition?.identifier === identifier);

      let arLines = [];
      let frLines = [];
      let enLines = [];

      if (conf.type === "surah") {
        const url = `https://api.alquran.cloud/v1/surah/${conf.surah}/editions/${AR_EDITION},${FR_EDITION},${EN_EDITION}`;
        const json = await fetchJson(url);

        const arBlock = pick(json.data, AR_EDITION);
        const frBlock = pick(json.data, FR_EDITION);
        const enBlock = pick(json.data, EN_EDITION);

        const arAyahs = (arBlock?.ayahs || []).map((a) => a.text).filter(Boolean);
        const frAyahs = (frBlock?.ayahs || []).map((a) => a.text).filter(Boolean);
        const enAyahs = (enBlock?.ayahs || []).map((a) => a.text).filter(Boolean);

        arLines = conf.forceBasmalaSeparation ? separateBasmalaIfNeeded(arAyahs) : arAyahs;
        frLines = frAyahs;
        enLines = enAyahs;
      }

      if (conf.type === "ayahs") {
        const arTmp = [];
        const frTmp = [];
        const enTmp = [];

        for (const key of conf.ayahs) {
          const url = `https://api.alquran.cloud/v1/ayah/${key}/editions/${AR_EDITION},${FR_EDITION},${EN_EDITION}`;
          const json = await fetchJson(url);

          const arBlock = pick(json.data, AR_EDITION);
          const frBlock = pick(json.data, FR_EDITION);
          const enBlock = pick(json.data, EN_EDITION);

          if (arBlock?.text) arTmp.push(arBlock.text);
          if (frBlock?.text) frTmp.push(frBlock.text);
          if (enBlock?.text) enTmp.push(enBlock.text);
        }

        arLines = arTmp;
        frLines = frTmp;
        enLines = enTmp;
      }

      setSleepContent((prev) => ({
        ...prev,
        [id]: { arLines, frLines, enLines },
      }));
    } catch (e) {
      setSleepContent((prev) => ({
        ...prev,
        [id]: { arLines: [], frLines: [], enLines: [] },
      }));
    } finally {
      setSleepLoading((prev) => ({ ...prev, [id]: false }));
    }
  };

  const openSleepRead = async (id) => {
    setSessionPaused(false);
    setSleepReadId(id);
    await ensureLoaded(id);
    goTo("sleep_read");
  };

  // =========================
  // ✅ RENDERS
  // =========================
  const renderAbout = () => {
    const isPlayingAbout = inlineAudioId === "about";
    const aboutSrc =
      language === "fr"
        ? "/audio/chevalet-about-fr.mp3"
        : "/audio/chevalet-about-en.mp3";

    return (
      <main className="night-screen about-screen">
        <div className="portrait-panel">
          <div className="panel-header-card">
            <h1 className="panel-title">{t.aboutTitle}</h1>

            <CollapsibleBlock
              t={t}
              preview={[t.aboutLine1, t.aboutLine2]}
              more={[
                t.aboutUseAtYourPace,
                `${t.aboutShareTitle}`,
                t.aboutShareText,
                `${t.aboutMoreTitle}`,
                t.aboutMoreText,
                t.aboutFreebieNote,
                `${t.aboutCreditsTitle}`,
                t.aboutCreditsText,
              ]}
            />

            <p className="panel-subtitle secondary" style={{ marginTop: "0.65rem" }}>
              <strong>{t.aboutListenTitle}</strong>
            </p>

            <button
              type="button"
              className="inline-audio-button"
              onClick={() =>
                isPlayingAbout ? stopInlineAudio() : playInlineAudio("about", aboutSrc)
              }
            >
              <span className="inline-audio-button-icon">{isPlayingAbout ? "⏸" : "▶"}</span>
              <span className="inline-audio-button-label">
                {isPlayingAbout ? t.aboutAudioPause : t.aboutAudioPlay}
              </span>
            </button>
          </div>

         <button
  className="primary-button verse-sleep-btn"
  onClick={() => goTo("welcome")}
>
  {language === "fr" ? "Accéder au support" : "Access the support"}
</button>


<button
  className="secondary-button back-button"
  onClick={() => goTo("reminder")}
>
  {language === "fr" ? "🔔 Activer mon rappel" : "🔔 Enable my reminder"}
</button>

          <button className="secondary-button back-button" onClick={() => goTo("mission")}>
            {t.aboutFreebieButton}
          </button>
    {PROMOS.donateButtonEnabled && (
  <a
    href="https://mafoiislamique.com/"
    target="_blank"
    rel="noopener noreferrer"
    className="promos-btn"
    style={{ textDecoration: "none", display: "block", textAlign: "center" }}
  >
    {language === "fr" ? "💗 Faire un don (optionnel)" : "💗 Donate (optional)"}
  </a>
)}

        </div>
      </main>
    );
  };

  const renderMission = () => (
    <main className="night-screen about-screen">
      <div className="portrait-panel">
        <div className="panel-header-card">
          <h1 className="panel-title">{t.missionTitle}</h1>
          <p className="panel-subtitle">{t.missionTagline}</p>

          <details className="mission-section" open>
            <summary className="mission-summary">{t.missionWhyTitle}</summary>
            <p className="panel-subtitle secondary mission-text">{t.missionWhyText}</p>
          </details>

          <details className="mission-section">
            <summary className="mission-summary">{t.missionIntentTitle}</summary>
            <p className="panel-subtitle secondary mission-text">{t.missionIntentText}</p>
          </details>

          <details className="mission-section">
            <summary className="mission-summary">{t.missionGoalTitle}</summary>
            <p className="panel-subtitle secondary mission-text">{t.missionGoalText}</p>
          </details>

          <details className="mission-section">
            <summary className="mission-summary">{t.missionOfferTitle}</summary>
            <p className="panel-subtitle secondary mission-text">{t.missionOfferText}</p>
          </details>

          <details className="mission-section">
            <summary className="mission-summary">{t.missionPrinciplesTitle}</summary>
            <p className="panel-subtitle secondary mission-text">{t.missionPrinciplesText}</p>
          </details>

          <details className="mission-section">
            <summary className="mission-summary">{t.missionAudienceTitle}</summary>
            <p className="panel-subtitle secondary mission-text">{t.missionAudienceText}</p>
          </details>

          <details className="mission-section">
            <summary className="mission-summary">{t.missionSupportTitle}</summary>
            <p className="panel-subtitle secondary mission-text">{t.missionSupportText}</p>
          </details>

          <div className="soft-note" style={{ marginTop: "0.75rem" }}>
            <p className="panel-subtitle" style={{ margin: 0 }}>
              <strong>{t.missionContactLabel}</strong> {t.missionContactValue}
            </p>
          </div>
        </div>

        <button className="primary-button back-button" onClick={() => goTo("about")}>
          {t.missionBack}
        </button>
      </div>
    </main>
  );

const renderWelcome = () => {
  const welcomeImage =
    themeMode === "day"
      ? language === "fr"
        ? accueilJourFr
        : accueilJourEn
      : language === "fr"
      ? chevaletFr
      : chevaletEn;

  return (
    <main className="welcome-screen">
      <div className="welcome-image-wrapper">
        <img
          src={welcomeImage}
          alt="Chevalet spirituel du soir"
          className="welcome-image"
        />

        <button
          type="button"
          className="welcome-about-button"
          onClick={() => goTo("about")}
        >
          {t.welcomeAboutButton}
        </button>

        {/* ✅ 2 boutons en bas */}
        <div className="welcome-actions">
          <button
            className="primary-button start-over-image-button"
            onClick={() => goTo("intro")}
          >
            {t.startButton}
          </button>

          <button
            type="button"
            className="secondary-button welcome-sleep-button"
            onClick={() => goTo("sleep")}
          >
            {language === "fr"
              ? "🌙 Invocations du sommeil"
              : "🌙 Sleep invocations"}
          </button>
        </div>
      <button
  type="button"
  className="secondary-button welcome-adhkar-button"
  onClick={() => goTo("adhkar_choice")}
>
  {language === "fr" ? "🌅 Adhkâr du matin/du soir" : "🌅 Morning/Evening adhkar"}
</button>

      </div>
    </main>
  );
};


  const renderIntro = () => {
    const isPlayingIntro = inlineAudioId === "intro";
    const introSrc =
      language === "fr"
        ? "/audio/chevalet-intro-fr.mp3"
        : "/audio/chevalet-intro-en.mp3";

    return (
      <main className="night-screen">
        <div className="portrait-panel">
          <div className="panel-header-card">
  
            <h1 className="panel-title">{t.introTitle}</h1>

            <CollapsibleBlock
  t={t}
  preview={[]}
  more={[
    t.introLine1,
    t.introLine2,
    t.introLine3,
    t.introLineExtra,
    t.introLine4,
    t.introLine5,
    t.introLine6,
  ]}
/>


            <p className="panel-subtitle secondary" style={{ marginTop: "0.55rem" }}>
              <strong>{t.introListenTitle}</strong> {t.introListenText}
            </p>

            <button
              type="button"
              className="inline-audio-button"
              onClick={() =>
                isPlayingIntro ? stopInlineAudio() : playInlineAudio("intro", introSrc)
              }
            >
              <span className="inline-audio-button-icon">{isPlayingIntro ? "⏸" : "▶"}</span>
              <span className="inline-audio-button-label">
                {isPlayingIntro ? t.introAudioPause : t.introAudioPlay}
              </span>
            </button>
          </div>
          <p
  className={`panel-subtitle dua-title ${duaColorClass}`}
  style={{ margin: "0.35rem 0 0.55rem", fontWeight: 900 }}
>
  {language === "fr" ? "Du’a du jour" : "Dua of the day"}
</p>

<p
  className={`panel-subtitle dua-card ${duaColorClass}`}

  style={{
    margin: "0.75rem 0 1.25rem",
    lineHeight: 1.55,
    opacity: 0.98,
    padding: "0.9rem 1rem",
    borderRadius: 14,
    background: "rgba(0,0,0,0.45)",
    border: "1px solid rgba(255,255,255,0.14)",
    backdropFilter: "blur(6px)",
    WebkitBackdropFilter: "blur(6px)",
    whiteSpace: "pre-line",
  }}
>
  {todayDua}
</p>

{/* ✅ Boutons optionnels (pilotés par remoteConfig) */}
{remoteConfig && (remoteConfig?.whyPray?.enabled || remoteConfig?.don?.enabled) && (
  <div style={{ marginTop: "0.85rem" }}>
   

    {/* DON */}
    {remoteConfig?.don?.enabled && (
      <button
        type="button"
        className="secondary-button back-button"
        onClick={() => {
          const url = (remoteConfig.don.url || "").trim();
          if (!url) return;
          window.open(url, "_blank", "noopener,noreferrer");
        }}
      >
        {language === "fr"
          ? (remoteConfig.don.labelFr || "Soutenir le projet (don)")
          : (remoteConfig.don.labelEn || "Support the project (donation)")}
      </button>
    )}

    {/* 🔄 Mettre à jour */}
    {process.env.NODE_ENV !== "production" && (
  <button
    type="button"
    className="header-chip header-chip--ghost"
    style={{ marginTop: "0.35rem" }}
    onClick={async () => {
      try {
        const cfg = await forceRefreshRemoteConfig();
        setRemoteConfig(cfg);
        window.alert(language === "fr" ? "✅ Mise à jour faite." : "✅ Updated.");
      } catch {
        window.alert(language === "fr" ? "❌ Impossible de mettre à jour." : "❌ Update failed.");
      }
    }}
    title={language === "fr" ? "Rafraîchir les annonces" : "Refresh announcements"}
  >
    🔄 {language === "fr" ? "Mettre à jour" : "Refresh"}
  </button>
)}

  </div>
)}

{PROMOS.newsButtonEnabled && (
 <NewsButton
  onClick={() => setWhyPrayOpen(true)}
  label={PROMOS.newsLabel}

/>
)}
{remoteConfig?.donButton?.enabled && (
  <DonateButton
    onClick={() => setDonateOpen(true)}
    label={
      language === "fr"
        ? (remoteConfig?.donButton?.labelFr || "Don (optionnel)")
        : (remoteConfig?.donButton?.labelEn || "Donate (optional)")
    }
  />
)}



          <button className="primary-button back-button" onClick={() => goTo("grid")}>
            {t.introButton}
          </button>
        </div>
      </main>
    );
  };

  const renderGrid = () => (
    <main className="night-screen">
      {showGridHint && (
        <div className="grid-hint-overlay">
          <div className="grid-hint-card">
            <button
              type="button"
              onClick={() => {
                setShowGridHint(false);
                try {
                  window.localStorage.setItem(GRID_HINT_STORAGE_KEY, "1");
                } catch {}
              }}
              className="grid-hint-close"
              aria-label="Close"
            >
              ×
            </button>

            <p className="grid-hint-title">{t.gridHintTitle}</p>

            <div className="grid-hint-lines">
              <div className="grid-hint-line">
                <span className="dot dot-green" />
                <span>{t.gridHintGreen}</span>
              </div>
              <div className="grid-hint-line">
                <span className="dot dot-yellow" />
                <span>{t.gridHintYellow}</span>
              </div>
              <div className="grid-hint-line">
                <span className="dot dot-red" />
                <span>{t.gridHintRed}</span>
              </div>
            </div>

            <p className="grid-hint-help">{t.gridHintHelp}</p>
          </div>
        </div>
      )}

      <div className="portrait-panel" style={{ marginTop: "0.15rem" }}>
        <div className="panel-header-card">
          <h1 className="panel-title">{t.gridTitle}</h1>
          <p className="panel-subtitle">{t.gridSubtitle}</p>

         <div className="grid-header-actions">
  <button type="button" className="header-chip" onClick={() => setShowGridHint(true)}>
    {t.gridHintButton}
  </button>

  {cycleDone && (
    <button
      type="button"
      className="header-chip header-chip--ghost"
      onClick={confirmResetTilesOnly}
      style={{ marginLeft: "10px" }}
      title={language === "fr" ? "Réinitialiser les 30 cases" : "Reset the 30 tiles"}
    >
      {language === "fr" ? "Réinitialiser" : "Reset"}
    </button>
  )}
</div>

        </div>

        <div className="tiles-grid" style={{ gap: "8px", marginTop: "0.6rem" }}>
         {TILES.map((tile) => {
  const isCompleted = completedTiles.includes(tile);
  const status = tileStatus[tile];

  // ✅ AJOUT : on empêche d'ouvrir une case déjà faite tant qu'il reste des cases grises
  const hasRemainingUncompleted = TILES.some((t) => !completedTiles.includes(t));

// ✅ Autoriser la case active tant que le délai n'est pas expiré
const canReopenActive =
  String(lockStateUI?.activeTileId ?? "") === String(tile) &&
  Date.now() < (lockStateUI?.activeUntil || 0);

// ✅ Bloquer les cases déjà validées, SAUF la case active encore dans le délai
const disableCompleted = isCompleted && hasRemainingUncompleted && !canReopenActive;
  let classes = "tile-button";
  if (isCompleted) classes += " tile-completed";
  if (status === "good") classes += " tile-good";
  else if (status === "medium") classes += " tile-medium";
  else if (status === "bad") classes += " tile-bad";

  return (
    <button
      key={tile}
      className={classes}
      onClick={() => onTileClick(tile)}
      disabled={disableCompleted}
      title={
        disableCompleted
          ? (language === "fr"
              ? "Case déjà validée — termine d’abord les cases grises."
              : "Already completed — finish grey tiles first.")
          : ""
      }
      style={{
        padding: "0.55rem 0.45rem",
        opacity: disableCompleted ? 0.55 : 1,
        cursor: disableCompleted ? "not-allowed" : "pointer",
      }}
    >
      <span className="tile-number">{tile}</span>
      <span className="tile-label">
        {language === "fr" ? "Case" : "Tile"} {tile}
      </span>
    </button>
  );
})}

        </div>

        <p className="bottom-tip" style={{ marginTop: "0.65rem" }}>
          {t.bottomTip}
        </p>
      </div>
    </main>
  );

  const renderTile = () => {
    const answersLabels = t.answers;
    const questions = language === "fr" ? QUESTIONS_FR : QUESTIONS_EN;
    const tileQuestions = getTileQuestions(questions, currentTile);

    const tileAnswers = answers[currentTile] || {};
    const hasAllAnswered = ["q1", "q2", "q3"].every((id) => !!tileAnswers[id]);

    const q1 = tileQuestions[0];
    const q2 = tileQuestions[1];
    const q3 = tileQuestions[2];

    const q1Intro = q1?.intro ? cleanIntro(q1.intro) : "";
    const q2Intro = q2?.intro ? cleanIntro(q2.intro) : "";
    const q3Intro = q3?.intro ? cleanIntro(q3.intro) : "";

    return (
      <main className="night-screen">
        <div className="portrait-panel">
          <div className="panel-header-card">
            <h1 className="panel-title">{t.tileTitle(currentTile)}</h1>
            <p className="panel-subtitle">{t.tileIntro1}</p>
            <p className="panel-subtitle secondary">{t.tileIntro2}</p>

           <div className="soft-note">
  <p className="panel-subtitle hadith-text" style={{ margin: 0 }}>
    {t.tileNonJudgment}
  </p>

  <p
    className="panel-subtitle secondary hadith-text"
    style={{ margin: "0.25rem 0 0" }}
  >
   {t.tileSpiritLine}
  </p>
</div>


            {t.tileColorNote && <CollapsibleBlock t={t} preview={[]} more={[t.tileColorNote]} />}
          </div>

          {q1 && (
            <div className="question-block">
              {q1Intro ? (
                <p className="panel-subtitle secondary" style={{ margin: "0 0 0.25rem" }}>
                  {q1Intro}
                </p>
              ) : null}

              <p className="question-text" style={{ margin: 0 }}>
                {q1.text}
              </p>

              <div className="answer-row" style={{ marginTop: "0.65rem" }}>
                {answersLabels.map((label, aIdx) => {
                  const value = `q1_${aIdx}`;
                  return (
                    <button
                      key={value}
                      className={
                        "answer-chip" + (isSelected(currentTile, "q1", value) ? " selected" : "")
                      }
                      onClick={() => handleAnswerClick(currentTile, "q1", value)}
                    >
                      {label}
                    </button>
                  );
                })}
              </div>
            </div>
          )}

          {q2 && (
            <CollapsibleQuestion summaryTitle={t.q2Title} intro={q2Intro} text={q2.text} defaultOpen={false}>
              <div className="answer-row">
                {answersLabels.map((label, aIdx) => {
                  const value = `q2_${aIdx}`;
                  return (
                    <button
                      key={value}
                      className={
                        "answer-chip" + (isSelected(currentTile, "q2", value) ? " selected" : "")
                      }
                      onClick={() => handleAnswerClick(currentTile, "q2", value)}
                    >
                      {label}
                    </button>
                  );
                })}
              </div>
            </CollapsibleQuestion>
          )}

          {q3 && (
            <CollapsibleQuestion summaryTitle={t.q3Title} intro={q3Intro} text={q3.text} defaultOpen={false}>
              <div className="answer-row">
                {answersLabels.map((label, aIdx) => {
                  const value = `q3_${aIdx}`;
                  return (
                    <button
                      key={value}
                      className={
                        "answer-chip" + (isSelected(currentTile, "q3", value) ? " selected" : "")
                      }
                      onClick={() => handleAnswerClick(currentTile, "q3", value)}
                    >
                      {label}
                    </button>
                  );
                })}
              </div>
            </CollapsibleQuestion>
          )}

          <button
            className="primary-button finish-button"
            disabled={!hasAllAnswered}
            onClick={() => {
              if (!hasAllAnswered) return;

              const yesCount = ["q1", "q2", "q3"].reduce((acc, qId) => {
                const v = tileAnswers[qId];
                if (v && v.endsWith("_0")) return acc + 1;
                return acc;
              }, 0);

              let status = "bad";
              if (yesCount >= 2) status = "good";
              else if (yesCount === 1) status = "medium";

              setTileStatus((prev) => ({ ...prev, [currentTile]: status }));

              setCompletedTiles((prev) => {
                const exists = prev.includes(currentTile);
                const updated = exists ? prev : [...prev, currentTile];
                if (updated.length === TILES.length) setCycleDone(true);
                return updated;
              });

              goTo("conclusion");
            }}
          >
            {t.finishButton}
          </button>
        </div>
      </main>
    );
  };

  const renderConclusion = () => {
    const isPlayingConclusion = inlineAudioId === "conclusion";
    const conclusionSrc =
      language === "fr"
        ? "/audio/chevalet-conclusion-fr.mp3"
        : "/audio/chevalet-conclusion-en.mp3";

    return (
      <main className="night-screen">
        <div className="portrait-panel">
          <div className="panel-header-card">
            <h1 className="panel-title">{t.conclusionTitle}</h1>

            <CollapsibleBlock
              t={t}
              preview={[t.conclusionLine1, t.conclusionLine2]}
              more={[
                t.conclusionLine3,
                t.conclusionDua,
                `${t.conclusionForYouTitle} ${t.conclusionForYouText}`,
                `${t.conclusionAdviceTitle} ${t.conclusionAdviceText}`,
                t.conclusionReminder,
              ]}
            />

            <details className="month-summary">
              <summary className="month-summary-title">📊 {t.monthSummaryTitle}</summary>

              <div className="month-summary-body">
                <p className="panel-subtitle secondary" style={{ margin: "0 0 0.35rem" }}>
                  ✅ {t.monthSummaryGreen} : <strong>{stats.green}</strong>
                </p>
                <p className="panel-subtitle secondary" style={{ margin: "0 0 0.35rem" }}>
                  🟡 {t.monthSummaryYellow} : <strong>{stats.yellow}</strong>
                </p>
                <p className="panel-subtitle secondary" style={{ margin: 0 }}>
                  🔴 {t.monthSummaryRed} : <strong>{stats.red}</strong>
                </p>

                <p className="panel-subtitle secondary" style={{ marginTop: "0.55rem" }}>
                  {language === "fr" ? (
                    <>
                      Total : <strong>{Math.max(stats.total, stats.completed)}</strong>/30
                    </>
                  ) : (
                    <>
                      Total: <strong>{Math.max(stats.total, stats.completed)}</strong>/30
                    </>
                  )}
                </p>

                <div className="soft-note month-summary-note">
                  <p className="panel-subtitle" style={{ margin: 0, fontWeight: 900 }}>
                    {t.monthSummaryNoteTitle}
                  </p>
                  <p className="panel-subtitle secondary" style={{ margin: "0.35rem 0 0" }}>
                    {t.monthSummaryNonJudgment}
                  </p>
                 <p className="month-summary-attention">
  {t.monthSummaryGreenNote}
</p>

                  <p className="panel-subtitle secondary" style={{ margin: "0.5rem 0 0" }}>
                    <strong>{t.monthSummaryHadith}</strong>
                  </p>
                  <p className="panel-subtitle secondary" style={{ margin: "0.35rem 0 0" }}>
                    {t.monthSummaryHadithHint}
                  </p>
                </div>
              </div>
            </details>

            <button
              type="button"
              className="inline-audio-button"
              onClick={() =>
                isPlayingConclusion
                  ? stopInlineAudio()
                  : playInlineAudio("conclusion", conclusionSrc)
              }
            >
              <span className="inline-audio-button-icon">{isPlayingConclusion ? "⏸" : "▶"}</span>
              <span className="inline-audio-button-label">
                {isPlayingConclusion ? t.conclusionAudioPause : t.conclusionAudioPlay}
              </span>
            </button>
          </div>

          <button className="secondary-button back-button" onClick={() => goTo("grid")}>
            {t.backToTiles}
          </button>

          <button className="primary-button back-button" onClick={() => goTo("verse")}>
            {t.conclusionListenButton}
          </button>
        </div>
      </main>
    );
  };

  const renderVerse = () => {
    const isPlayingVerse = inlineAudioId === "verse";
    const verseSrc = "/audio/chevalet-verset-arabe.mp3";

    return (
      <main className="night-screen">
        <div className="portrait-panel">
          <div className="panel-header-card">
           <h1 className="panel-title">{t.verseTitle}</h1>

{/* 1) Traduction + référence (ton texte qui commence par « Dis : ... » + (Sourate 39, verset 53)) */}
<p className="panel-subtitle">{t.verseRef}</p>

{/* 2) Arabe (BLANC, fin / pas gras) */}
<p
  className="panel-subtitle verse-arabic"
  dir="rtl"
  lang="ar"
  style={{
    color: "#fff",
    marginTop: "0.6rem",
    fontSize: "1.65rem",
    lineHeight: 2.2,
    textAlign: "right",
  }}
>
  قُلْ يَٰعِبَادِىَ ٱلَّذِينَ أَسْرَفُوا۟ عَلَىٰٓ أَنفُسِهِمْ لَا تَقْنَطُوا۟ مِن رَّحْمَةِ ٱللَّهِ ۚ إِنَّ ٱللَّهَ يَغْفِرُ ٱلذُّنُوبَ جَمِيعًا ۚ إِنَّهُۥ هُوَ ٱلْغَفُورُ ٱلرَّحِيمُ
</p>


{/* 3) “Même si …” (TON texte) — juste sous l’arabe */}
<p className="panel-subtitle secondary">{t.verseText}</p>

{/* 4) Consigne “Lis ce verset …” */}
<p className="panel-subtitle secondary">{t.verseHint}</p>


            <button
              type="button"
              className="inline-audio-button"
              onClick={() =>
                isPlayingVerse ? stopInlineAudio() : playInlineAudio("verse", verseSrc)
              }
            >
              <span className="inline-audio-button-icon">{isPlayingVerse ? "⏸" : "▶"}</span>
              <span className="inline-audio-button-label">
                {isPlayingVerse ? t.verseAudioPause : t.verseAudioPlay}
              </span>
            </button>
          </div>

        <div className="verse-actions">
  {/* 1) Accueil du Muhasaba (en haut) */}
  <button className="secondary-button" onClick={() => goTo("welcome")}>
    {t.verseButton}
  </button>

  {/* 2) Partager l’app (à côté) */}
  <button
    className="secondary-button"
    onClick={async () => {
      const res = await shareMuhasabaApp(language);
      if (res?.method === "clipboard") {
        window.alert(
          language === "fr"
            ? "✅ Lien copié. Tu peux le coller dans WhatsApp / SMS."
            : "✅ Link copied. You can paste it in WhatsApp / SMS."
        );
      }
    }}
  >
    {language === "fr" ? "Partager l’app" : "Share the app"}
  </button>

  {/* 3) Adhkâr matin/soir (pleine largeur) */}
  <button
    className="secondary-button verse-action-full"
    onClick={() => goTo("adhkar_choice")}
  >
    ☀️/🌙 {language === "fr" ? "Adhkâr matin/soir" : "Morning/Evening Adhkar"}
  </button>

  {/* 4) Invocations du sommeil (en bas, pleine largeur) */}
  <button className="primary-button verse-action-full" onClick={() => goTo("sleep")}>
    {t.sleepTitle}
  </button>
</div>

        </div>
      </main>
    );
  };

  // =========================
  // ✅ PAPER
  // =========================
  const renderPaper = () => {
    const url = language === "fr" ? PAPER_EASEL_URL_FR : PAPER_EASEL_URL_EN;
    const hasUrl = !!url && url.trim().length > 0;

    return (
      <main className="night-screen">
        <div className="portrait-panel">
          <div className="panel-header-card">
            <h1 className="panel-title">{t.paperTitle}</h1>
            <p className="panel-subtitle">{t.paperSubtitle}</p>

            <div className="paper-card">
              <p className="paper-card-title">{t.paperWhatTitle}</p>
              <p className="panel-subtitle secondary paper-text">{t.paperWhatText}</p>
            </div>

            <div className="paper-card" style={{ marginTop: "0.7rem" }}>
              <p className="paper-card-title">{t.paperDownloadTitle}</p>
              <p className="panel-subtitle secondary" style={{ marginTop: "0.35rem" }}>
                {t.paperDownloadText}
              </p>

              <button
                type="button"
                className={"primary-button paper-download-btn" + (hasUrl ? "" : " disabled")}
                onClick={() => {
                  if (!hasUrl) return;
                  window.open(url, "_blank");
                }}
                disabled={!hasUrl}
              >
                {t.paperDownloadBtn}
              </button>

              {!hasUrl ? (
                <p className="panel-subtitle secondary" style={{ marginTop: "0.5rem" }}>
                  ⏳ {t.sleepTipSoon}
                </p>
              ) : null}
            </div>
          </div>

          <button className="secondary-button back-button" onClick={() => goTo("sleep")}>
            {t.paperBackBtn}
          </button>
        </div>
      </main>
    );
  };

  // =========================
  // ✅ SLEEP LIST
  // =========================
  const renderSleep = () => {
    const checkedCount = sleepProgressCount;
    const totalCount = SLEEP_TRACKS.length;

   const decAr = () => setSleepArScale((s) => Math.max(0.9, Math.round((s - 0.1) * 100) / 100));
const incAr = () => setSleepArScale((s) => Math.min(2.2, Math.round((s + 0.1) * 100) / 100));


    return (
      <main className="night-screen">
        <div className="portrait-panel" style={{ marginTop: "0.15rem" }}>
          <div className="panel-header-card sleep-header-sticky">
            <div className="sleep-top-actions">
              {/* ✅ IMPORTANT : Retour au chevalet = accueil */}
             
              <div className="ar-size-controls" title={t.arSizeHint} aria-label={t.arSizeHint}>
                <button type="button" className="header-chip" onClick={decAr}>
                  {t.arSmaller}
                </button>
                <button type="button" className="header-chip" onClick={incAr}>
                  {t.arBigger}
                </button>
              </div>
            </div>

            <p className="panel-subtitle secondary" style={{ margin: "0.35rem 0 0", opacity: 0.92 }}>
              {t.sleepArHelp}
            </p>

            <div className="sleep-progress" style={{ marginTop: "0.65rem" }}>
              <div className="sleep-progress-top">
                <p className="sleep-progress-title">
                  {t.sleepProgress} : {checkedCount}/{totalCount}
                </p>
                <p className="sleep-progress-hint">{t.sleepProgressHint}</p>
              </div>

              {checkedCount === totalCount ? (
                <div className="sleep-done">
                  <p style={{ margin: 0, fontWeight: 900 }}>{t.sleepDoneTitle}</p>
                  <p style={{ margin: "0.25rem 0 0", opacity: 0.92 }}>{t.sleepDoneText}</p>
                </div>
              ) : null}
            </div>
          </div>

          <div style={{ marginTop: "0.85rem" }}>
            {SLEEP_TRACKS.map((trk) => {
              const isPlaying = inlineAudioId === trk.id;

              return (
                <div key={trk.id} className="sleep-track-card">
                  <div className="sleep-track-title">{trk.title}</div>

                  {/* ✅ Barre 3 boutons : Fait / Écouter / Lire */}
                  <div className="sleep-mini-bar">
                    <label className="sleep-mini-check">
                      <input
                        type="checkbox"
                        checked={!!sleepChecked[trk.id]}
                        onChange={() => toggleSleepChecked(trk.id)}
                      />
                      <span>{t.sleepChecked}</span>
                    </label>

                    {trk.src ? (
                      <button
                        type="button"
                        className={"sleep-mini-btn" + (isPlaying ? " is-playing" : "")}
                        onClick={() => (isPlaying ? stopInlineAudio() : playInlineAudio(trk.id, trk.src))}
                        aria-label={isPlaying ? t.sleepPause : t.sleepPlay}
                        title={isPlaying ? t.sleepPause : t.sleepPlay}
                      >
                        <span className="sleep-mini-icon">{isPlaying ? "⏸" : "▶︎"}</span>
                        <span>{isPlaying ? t.sleepPause : t.sleepPlay}</span>
                      </button>
                    ) : null}

                    <button
                      type="button"
                      className="sleep-mini-btn"
                      onClick={() => openSleepRead(trk.id)}
                    >
                      {language === "fr" ? "Lire" : "Read"}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>

          {/* ✅ Astuce (texte dans TEXTS, on garde ici la mise en forme) */}
          <div className="sleep-tip" style={{ marginTop: "0.65rem" }}>
            <p className="panel-subtitle" style={{ margin: 0, fontWeight: 800 }}>
              {t.sleepTipTitle} :
            </p>
            <p className="panel-subtitle secondary" style={{ margin: "0.25rem 0 0" }}>
              {t.sleepTipText}
            </p>

            <button type="button" className="secondary-button paper-tip-btn" onClick={() => goTo("paper")}>
              {t.sleepTipBtn}
            </button>
          </div>
        </div>
      </main>
    );
  };

  // =========================
  // ✅ SLEEP READ (page dédiée)
  // =========================
  const renderSleepRead = () => {
    const id = sleepReadId;
    const trk = SLEEP_TRACKS.find((x) => x.id === id);
    // ✅ Compteur dhikr uniquement pour les 3 lignes (Subhan / Alhamd / Akbar)
const dhikrTarget =
  id === "dhikr_subhanallah"
    ? 33
    : id === "dhikr_alhamdulillah"
    ? 33
    : id === "dhikr_allahuakbar"
    ? 34
    : null;

const showDhikrCounter = Number.isFinite(dhikrTarget);

    const isPlaying = inlineAudioId === id;
    const content = id ? sleepContent[id] : null;
    const loading = id ? !!sleepLoading[id] : false;

    const safeJoin = (lines) => (Array.isArray(lines) ? lines.join("\n\n") : "");
const decAr = () =>
  setSleepArScale((s) => Math.max(0.9, Math.round((s - 0.1) * 100) / 100));

const incAr = () =>
  setSleepArScale((s) => Math.min(2.2, Math.round((s + 0.1) * 100) / 100));


    return (
      <main className="night-screen">
        <div className="portrait-panel">
          <div className="panel-header-card sleep-read-header">
            <div className="sleep-read-top">
              <button
                type="button"
                className="secondary-button back-button"
                onClick={() => goTo("sleep")}
                style={{ marginTop: 0 }}
              >
                {language === "fr" ? "Retour aux invocations" : "Back to invocations"}
              </button>

              <div className="sleep-read-actions">
  <label className="sleep-read-check">
    <input
      type="checkbox"
      checked={!!sleepChecked[id]}
      onChange={() => toggleSleepChecked(id)}
    />
    <span>{t.sleepChecked}</span>
  </label>

  {/* ✅ A− / A+ directement ici */}
  <div className="sleep-read-ar-controls" title={t.arSizeHint} aria-label={t.arSizeHint}>
    <button type="button" className="header-chip" onClick={decAr}>
      {t.arSmaller}
    </button>
    <button type="button" className="header-chip" onClick={incAr}>
      {t.arBigger}
    </button>
  </div>

  {trk?.src ? (
    <button
      type="button"
      className={"sleep-mini-btn" + (isPlaying ? " is-playing" : "")}
      onClick={() => (isPlaying ? stopInlineAudio() : playInlineAudio(id, trk.src))}
    >
      <span className="sleep-mini-icon">{isPlaying ? "⏸" : "▶︎"}</span>
      <span>{isPlaying ? t.sleepPause : t.sleepPlay}</span>
    </button>
  ) : null}
</div>

            </div>

           <p className="sleep-read-hint">
  {language === "fr"
    ? "Récite, lis, ou écoute calmement, sans te presser. Tu peux ajuster la taille du texte avec A− / A+ ici."
    : "Recite, read, or listen calmly. You can adjust the text size with A− / A+ here."}
</p>

          </div>

          <div className="sleep-read-card">
         {showDhikrCounter && (
  <div style={{ marginBottom: "0.9rem" }}>
  <DhikrCounter
  key={id}
  counterId={id}
  target={dhikrTarget}
  variant="sleep"
  dailyReset={true}
/>

  </div>
)}

            {loading ? (
              <p className="panel-subtitle secondary" style={{ margin: 0 }}>
                {t.loadingText}
              </p>
            ) : (
              <>
                {content?.arLines?.length ? (
                  <p
                    className="sleep-arabic sleep-arabic--read"
                    style={{
                      fontSize: `${1.38 * sleepArScale}rem`,
                      lineHeight: 2.05,
                    }}
                  >
                    {safeJoin(content.arLines)}
                  </p>
                ) : null}

                {/* bismika => translit + traduction selon langue */}
                {id === "bismika" && content?.translit ? (
                  <div style={{ marginTop: "1rem" }}>
                    <p className="sleep-read-label">{t.translitLabel}</p>
                   <p
  className="sleep-trans"
  style={{ fontSize: `${1.02 * sleepArScale}rem`, lineHeight: 1.65 }}
>
  {content.translit}
</p>

                  </div>
                ) : null}

                {language === "fr" && content?.frLines?.length ? (
                  <div style={{ marginTop: "1.05rem" }}>
                    <p className="sleep-read-label">FR</p>
                   <p
  className="sleep-trans"
  style={{ fontSize: `${1.05 * sleepArScale}rem`, lineHeight: 1.75 }}
>
  {safeJoin(content.frLines)}
</p>

                  </div>
                ) : null}

                {language === "en" && content?.enLines?.length ? (
                  <div style={{ marginTop: "1.05rem" }}>
                    <p className="sleep-read-label">EN</p>
                   <p
  className="sleep-trans"
  style={{ fontSize: `${1.05 * sleepArScale}rem`, lineHeight: 1.75 }}
>
  {safeJoin(content.enLines)}
</p>

                  </div>
                ) : null}

                {!content?.arLines?.length && !content?.frLines?.length && !content?.enLines?.length ? (
                  <p className="panel-subtitle secondary" style={{ margin: 0 }}>
                    {language === "fr"
                      ? "Impossible de charger le texte pour le moment. Vérifie ta connexion et réessaie."
                      : "Unable to load the text right now. Check your connection and try again."}
                  </p>
                ) : null}
              </>
            )}
          </div>
        </div>
      </main>
    );
  };

  // =========================
  // ✅ Header: boutons visibles seulement quand il faut
  // =========================
 const PROMOS = React.useMemo(() => {
  const cfg = remoteConfig || {};

  return {
    newsButtonEnabled: !!cfg?.news?.enabled,
    whyPrayPopupEnabled: !!cfg?.whyPray?.enabled,
    donateButtonEnabled: !!cfg?.donButton?.enabled,
    donatePopupEnabled: !!cfg?.donPopup?.enabled, // (plus tard 1/an)

    newsLabel:
      language === "fr"
        ? (cfg?.news?.labelFr || "Nouveauté")
        : (cfg?.news?.labelEn || "New"),

    whyPrayUrl: (cfg?.whyPray?.url || "").trim(),
    donateUrl: (cfg?.donButton?.url || "").trim(),
  };
}, [remoteConfig, language]);


  const showQuitButton = view === "sleep" || view === "sleep_read";
const isIntroTopbar = view === "welcome" || view === "about";

  // ✅ Réinitialiser visible seulement sur le bilan (30 cases)
 
  // ✅ Bande en haut (transparent)
  const headerStyle = isIntroTopbar
  ? {
      background: "rgba(245, 234, 215, 0.95)", // beige clair
      backdropFilter: "blur(6px)",
      WebkitBackdropFilter: "blur(6px)",
      borderBottom: "1px solid rgba(0,0,0,0.08)",
    }
  : {
      background: "transparent",
      backdropFilter: "none",
      WebkitBackdropFilter: "none",
      borderBottom: "none",
    };
// ✅ Override topbar UNIQUEMENT pour Mission (jour + nuit)
const headerStyleFinal =
  view === "mission"
    ? {
        ...headerStyle,
        background: "rgba(60, 38, 20, 0.55)",
        backgroundColor: "rgba(60, 38, 20, 0.55)",
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)",
        borderBottom: "1px solid rgba(255,255,255,0.08)",
      }
    : headerStyle;

  return (
  <div
  className={`app view-${view} theme-${uiThemeMode} ${isDayContent ? "day-content" : ""}`}
  style={appShellStyle}
>

  <header
  className={`app-header app-header--fixed ${isIntroTopbar ? "app-header--intro" : ""} ${view === "mission" ? "topbar-mission" : ""}`}
  style={headerStyleFinal}
>

        <div className="language-switch">
          <button className={"lang-pill" + (language === "fr" ? " active" : "")} onClick={() => setLanguage("fr")}>
            {t.langFr}
          </button>
          <button className={"lang-pill" + (language === "en" ? " active" : "")} onClick={() => setLanguage("en")}>
            {t.langEn}
          </button>
          <button
    type="button"
    className="lang-pill"
    onClick={() => setThemeModalOpen(true)}
    title="Changer le mode Jour/Nuit"
  >
    ☀️/🌙
  </button>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
         

          {showQuitButton && (
            <button
              type="button"
              className="header-chip header-chip--ghost"
              onClick={quitForTonight}
              aria-label={t.quitTonight}
              title={t.quitTonight}
            >
              {t.quitTonight}
            </button>
          )}

          <button
            className="bg-toggle"
            onClick={() => {
              setSessionPaused(false);
              setBackgroundOn((v) => !v);
            }}
          >
            <span className="bg-toggle-icon">{backgroundOn ? "🔊" : "🔇"}</span>
            <span className="bg-toggle-label">{backgroundOn ? t.bgOn : t.bgOff}</span>
          </button>
        </div>
      </header>

      {view === "about" && renderAbout()}
      {view === "mission" && renderMission()}
      {view === "welcome" && renderWelcome()}
      {view === "intro" && renderIntro()}
      {view === "grid" && renderGrid()}
      {view === "tile" && renderTile()}
      {view === "conclusion" && renderConclusion()}
      {view === "verse" && renderVerse()}
      {view === "sleep" && renderSleep()}
      {view === "sleep_read" && renderSleepRead()}
     {view === "paper" && renderPaper()}
{(view === "adhkar_choice" || view === "adhkar_morning" || view === "adhkar_evening") && (
  <AdhkarPage view={view} language={language} goTo={goTo} />
)}

{view === "reminder" && (
  <ReminderSettings
    language={language}
    onBack={() => setView("welcome")}

  />
)}

{PROMOS.newsButtonEnabled && (
  <WhyPrayPopup
    open={whyPrayOpen}
    onClose={() => setWhyPrayOpen(false)}
    title={
      language === "fr"
        ? (remoteConfig?.whyPray?.titleFr || "Pourquoi prie-t-on ?")
        : (remoteConfig?.whyPray?.titleEn || "Why do we pray?")
    }
  >
    <p style={{ marginTop: 0, whiteSpace: "pre-line" }}>
      {language === "fr"
        ? (remoteConfig?.whyPray?.bodyFr || "")
        : (remoteConfig?.whyPray?.bodyEn || "")}
    </p>

    {!!(remoteConfig?.whyPray?.url || "").trim() && (
      <a
        href={(remoteConfig?.whyPray?.url || "").trim()}
        target="_blank"
        rel="noopener noreferrer"
        className="primary-button"
        onClick={() => setWhyPrayOpen(false)}
        style={{ display: "inline-block", textDecoration: "none" }}
      >
        {language === "fr"
          ? (remoteConfig?.whyPray?.ctaFr || "Je découvre !")
          : (remoteConfig?.whyPray?.ctaEn || "Discover")}
      </a>
    )}
  </WhyPrayPopup>
)}


{remoteConfig?.donPopup?.enabled && (
 <AnnualDonatePopup
  open={donateOpen}
  onClose={() => setDonateOpen(false)}
  title={language === "fr" ? "Soutenir ce projet" : "Support this project"}
  language={language}
  >
    <p style={{ marginTop: 0 }}>
      {language === "fr"
        ? "Si ce support t’aide au quotidien, Alhamdulillah. Si tu souhaites soutenir ce travail (c’est tout à fait optionnel), le bouton « Faire un don » se trouve dans la page (À propos). BarakAllahu fik."
        : "If this support helps you daily, Alhamdulillah. If you’d like to support this work (it’s completely optional), the «Donate» button is on the About page. BarakAllahu fik."}
    </p>

    <div className="promo-modal-footer">
      <button
        type="button"
        className="primary-button"
        onClick={() => {
          setDonateOpen(false);
          goTo("about");
        }}
      >
        {language === "fr" ? "Aller à « À propos »" : 'Go to "About"'}
      </button>
    </div>
  </AnnualDonatePopup>
)}


      <audio ref={audioRef} src={fondChevaletAudio} />
   <ThemeModal
  open={themeModalOpen}
  language={language}
  onChoose={handleChooseTheme}
/>

    </div>
  );
}

export default App;
